import "reactflow/dist/style.css";
import React, {
  useState,
  useCallback,
  useRef,
  Fragment,
  useEffect,
  useContext,
} from "react";
import Modal from "@mui/material/Modal";
import Switch from "@mui/material/Switch";
import { makeStyles } from "@material-ui/core";
import { Box, Fade, TextField, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import CloseIcon from "@mui/icons-material/Close";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import GreetingEmail from "./GreetingEmail";
import fillgreen from "../Images/Active Full fill green.png";
import ReactDOMServer from "react-dom/server";
import Context from "../Contex/Context";
import { useHistory } from "react-router-dom";
import EmailEditorWork from "../Editor/EmailEditorWork";
import DrawerClassCampaign from "./DrawerClassCampaign";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { DatePicker, Drawer } from "rsuite";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import { Prompt } from "react-router";
import { PlusCircleSvg, VariablLightSvg } from "../CommonSvgs";
import { SequenceEditor } from "./SequenceEditor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Backdrop from "@mui/material/Backdrop";

import ReactFlow, {
  Controls,
  Background,
  applyNodeChanges,
  applyEdgeChanges,
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  useReactFlow,
  getRectOfNodes,
  getTransformForBounds,
} from "reactflow";
import { toPng } from "html-to-image";
import CustomNode from "./CustomNode";
import BaseUrl from "../BaseUrl";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
// import notEmptyImage from "../Images/notempty.svg";
import notEmptyImage from "../Images/nolist.svg";
import ImportOptionsCopy from "../Contacts/ImportOptionCopy";
import EmailAccountsCopy from "./EmailAccountsCopy";
import CreateScheduleDrawer from "../Components/CreateScheduleDrawer";

const nodeTypes = {
  custom: CustomNode,
};
const imageWidth = 1024;
const imageHeight = 768;

let id = 0;
const getId = () => `dndnode_${id++}`;

const useStyles = makeStyles((theme) => ({
  modal: {
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    },
  },
  modalPopupDelete: {
    // Add your modalPopupDelete styles here
  },
  modaltext: {
    // Add your modaltext styles here
  },
  modalsubtext: {
    // Add your modalsubtext styles here
  },
}));

const steps = [
  { name: "Warm-up settings", href: "#", status: "complete", id: 1 },
  { name: "Strategy type", href: "#", status: "complete", id: 2 },
  { name: "Email content", href: "#", status: "current", id: 3 },
  { name: "Review", href: "#", status: "upcoming", id: 4 },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
};

export default function NewCampaignCopy(props) {
  const bottomRef = useRef(null);
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const classes = useStyles();
  const locData = useLocation();
  // console.log("kssdfsadjfkdsjf================>", locData.state.isEnableSequence);
  const history = useHistory();
  const { setAllNodes, setHoveredNode, setAllEdges, setErroredNode } =
    useContext(Context);
  const [open3, setOpen3] = useState(false);
  const [enable, setEnable] = useState(false);
  const [bccStatus, setBccStatus] = useState(false);
  const [campDuration, setCampDuration] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [newSchedule, setNewSchedule] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [sequenceLoader, setSequenceLoader] = useState(false);
  const [subject, setSubject] = useState("");
  const [subjectB, setSubjectB] = useState("");
  const [nodeErrorMessage, setNodeErrorMessage] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [emailBodyB, setEmailBodyB] = useState("");
  const [shceduleName, setScheduleName] = useState("");
  const [triggerValue, setTriggerValue] = useState("opened");
  const [abTestingStratergy, setAbTestingStratergy] = useState("Opened");
  const [emailType, setEmailType] = useState("");
  const [checkType, setCheckType] = useState("");
  const [triggSideType, setTriggSideType] = useState("");
  const [variableArray, setVariableArray] = useState([]);
  const [ccEmails, setCCEmails] = useState([]);
  const [bccEmails, setBccEmails] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState("");
  const [open, setOpen] = useState(false);
  const [open7, setOpen7] = useState(false);
  const [erorMessage, setErrorMessage] = useState([]);
  const [nameListArr, setNameListArr] = useState([]);
  const [campStartDate, setCampStartDate] = useState(new Date());
  const [campStartTime, setCampStartTime] = useState("12:00 AM");
  const [campEndDate, setCampEndDate] = useState(new Date());
  const [campEndTime, setCampEndTime] = useState("12:00 AM");
  const [showToaster, setShowToaster] = useState(false);
  const [emailRiskType, setEmailRiskType] = useState([
    { name: "Unverified", value: false },
    { name: "Unverifiable", value: true },
  ]);
  const [trackingType, setTrackingType] = useState([
    { name: "clicks", value: false },
    { name: "opens", value: false },
    { name: "stop", value: false },
  ]);
  const [type, setType] = useState("prospect");
  const [sequenceStatus, setSequenceStatus] = useState(true);
  const [timeLimit, setTimeLimit] = useState(2);
  const [timingZone, setTimingZone] = useState("");
  const [selected, setSelected] = useState("");
  const [goalName, setGoalName] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [body, setBody] = useState("");
  const [fromSchedule, setFromSchedule] = useState("");
  const [toSchedule, setToSchedule] = useState("");
  const handleClose = () => setOpen3(false);
  const reactFlowWrapper = useRef(null);
  const [addedNodes, setAddedNodes] = useState([]);
  const [selPosition, setSelPosition] = useState("");
  const handleCustomNodeEvent2 = useCallback((node) => {
    setOpen5(true);
    setSelPosition(node);
  }, []);
  const initialNodes = [
    {
      id: "1",
      type: "custom",
      data: {
        label: "Start",
        handleEvent2: handleCustomNodeEvent2,
      },
      BackendData: {
        bottom: "",
        top: "",
      },
      position: { x: 470, y: 5 },
    },
  ];
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [savedEdges, setSavedEdges] = useState(null);
  const [nameListObj, setNameListObj] = useState("");
  const [imageSrc, setImageSrc] = useState(null);
  const [selectedDays, setSelectedDays] = useState([
    { name: "Sunday", value: false },
    { name: "Monday", value: false },
    { name: "Tuesday", value: false },
    { name: "Wednesday", value: false },
    { name: "Thursday", value: false },
    { name: "Friday", value: false },
    { name: "Saturday", value: false },
  ]);
  const daysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"];
  const daysList2 = ["Friday", "Saturday"];
  const timeList = [
    "1:00 AM",
    "2:00 AM",
    "3:00 AM",
    "4:00 AM",
    "5:00 AM",
    "6:00 AM",
    "7:00 AM",
    "8:00 AM",
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 AM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
    "5:00 PM",
    "6:00 PM",
    "7:00 PM",
    "8:00 PM",
    "9:00 PM",
    "10:00 PM",
    "11:00 PM",
    "12:00 PM",
  ];

  const customEdgeStyles = {
    animated: true, // You can set this to true for animated edges
    label: "Custom Edge", // Optional label for the edge
    strokeWidth: 2, // Width of the edge line
    stroke: "#1C485F", // Color of the edge
    strokeLinecap: "round", // Line cap style ("round", "butt", or "square")
    strokeLinejoin: "round", // Line join style ("round", "bevel", or "miter")
  };
  const [daylistArr, setDayListArr] = useState([
    {
      Day: "Sunday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Monday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Tuesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Wednesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Thursday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Friday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Saturday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
  ]);
  const abtestingArr = ["Reply Rate", "Click Rate", "Open Rate"];
  const timezoneArr = [
    "(UTC-12:00) International Date Line West",
    "(UTC-11:00) Coordinated Universal Time-11",
    "(UTC-10:00) Hawaii",
    "(UTC-09:00) Alaska",
    "(UTC-08:00) Baja California",
    "(UTC-08:00) Pacific Time (US and Canada)",
    "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    "(UTC-07:00) Arizona",
    "(UTC-07:00) Mountain Time (US and Canada)",
    "(UTC-06:00) Central America",
    "(UTC-06:00) Central Time (US and Canada)",
    "(UTC-06:00) Saskatchewan",
    "(UTC-06:00) Guadalajara, Mexico City, Monterey",
    "(UTC-05:00) Bogota, Lima, Quito",
    "(UTC-05:00) Indiana (East)",
    "(UTC-05:00) Eastern Time (US and Canada)",
    "(UTC-04:30) Caracas",
    "(UTC-04:00) Atlantic Time (Canada)",
    "(UTC-04:00) Asuncion",
    "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    "(UTC-04:00) Cuiaba",
    "(UTC-04:00) Santiago",
    "(UTC-03:30) Newfoundland",
    "(UTC-03:00) Brasilia",
    "(UTC-03:00) Greenland",
    "(UTC-03:00) Cayenne, Fortaleza",
    "(UTC-03:00) Buenos Aires",
    "(UTC-03:00) Montevideo",
    "(UTC-02:00) Coordinated Universal Time-2",
    "(UTC-01:00) Cape Verde",
    "(UTC-01:00) Azores",
    "(UTC+00:00) Casablanca",
    "(UTC+00:00) Monrovia, Reykjavik",
    "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    "(UTC+00:00) Coordinated Universal Time",
    "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    "(UTC+01:00) West Central Africa",
    "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "(UTC+01:00) Windhoek",
    "(UTC+02:00) Athens, Bucharest, Istanbul",
    "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "(UTC+02:00) Cairo",
    "(UTC+02:00) Damascus",
    "(UTC+02:00) Amman",
    "(UTC+02:00) Harare, Pretoria",
    "(UTC+02:00) Jerusalem",
    "(UTC+02:00) Beirut",
    "(UTC+03:00) Baghdad",
    "(UTC+03:00) Minsk",
    "(UTC+03:00) Kuwait, Riyadh",
    "(UTC+03:00) Nairobi",
    "(UTC+03:30) Tehran",
    "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
    "(UTC+04:00) Tbilisi",
    "(UTC+04:00) Yerevan",
    "(UTC+04:00) Abu Dhabi, Muscat",
    "(UTC+04:00) Baku",
    "(UTC+04:00) Port Louis",
    "(UTC+04:30) Kabul",
    "(UTC+05:00) Tashkent",
    "(UTC+05:00) Islamabad, Karachi",
    "(UTC+05:30) Sri Jayewardenepura Kotte",
    "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "(UTC+05:45) Kathmandu",
    "(UTC+06:00) Astana",
    "(UTC+06:00) Dhaka",
    "(UTC+06:00) Yekaterinburg",
    "(UTC+06:30) Yangon",
    "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    "(UTC+07:00) Novosibirsk",
    "(UTC+08:00) Krasnoyarsk",
    "(UTC+08:00) Ulaanbaatar",
    "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "(UTC+08:00) Perth",
    "(UTC+08:00) Kuala Lumpur, Singapore",
    "(UTC+08:00) Taipei",
    "(UTC+09:00) Irkutsk",
    "(UTC+09:00) Seoul",
    "(UTC+09:00) Osaka, Sapporo, Tokyo",
    "(UTC+09:30) Darwin",
    "(UTC+09:30) Adelaide",
    "(UTC+10:00) Hobart",
    "(UTC+10:00) Yakutsk",
    "(UTC+10:00) Brisbane",
    "(UTC+10:00) Guam, Port Moresby",
    "(UTC+10:00) Canberra, Melbourne, Sydney",
    "(UTC+11:00) Vladivostok",
    "(UTC+11:00) Solomon Islands, New Caledonia",
    "(UTC+12:00) Coordinated Universal Time+12",
    "(UTC+12:00) Fiji, Marshall Islands",
    "(UTC+12:00) Magadan",
    "(UTC+12:00) Auckland, Wellington",
    "(UTC+13:00) Nuku'alofa",
    "(UTC+13:00) Samoa",
  ];
  const [waiting, setWaiting] = useState("Days");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [waitingDelay, setWaitingDelay] = useState("Days");
  const [count, setCount] = useState(1);
  const [nameList, setNameList] = useState("");
  const [nameListObject, setNameListObject] = useState([]);
  const [nameListId, setNameListId] = useState("");
  const [countryTimeSchedule, setCountryTimeSchdule] = useState(null);
  const [countryTimeSchedule2, setCountryTimeSchdule2] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [senderMail, setSenderMail] = useState("");
  const [noNameList, setNoNameList] = useState("");
  const [count1, setCount1] = useState(1);
  const [scheduleData, setScheduleData] = useState([]);
  const [senderMails, setSenderMails] = useState([]);
  const [listName, setListName] = useState("");
  const [back, setBack] = useState(false);
  const [abTestingStatus, setABTestingStatus] = useState(false);
  const [abTestingWin, setAbTestingWin] = useState("Reply Rate");
  const [listLoader, setListLoader] = useState(true);
  const { getNodes } = useReactFlow();
  const [isValid, setIsValid] = useState(true);
  const [openDrawerForCreateList, setOpenDrawerForCreateList] = useState(false);

  const handleCloseDrawer = (received) => {
    setOpenDrawerForCreateList(received);
    getAllNameList();
  };
  const [selectedSequence, setSelectedSequence] = useState(1);
  const [sequenceData, setSequenceData] = useState([
    {
      id: "1",
      data: { label: "Start" },
      BackendData: {
        top: "",
        bottom: "dndnode_0",
      },
    },
    {
      id: "dndnode_0",
      data: { label: "email" },
      BackendData: {
        data: {
          ABTesting: false,
          subject: "",
          body: ``,
          subjectA: "",
          bodyA: ``,
          subjectB: "",
          bodyB: ``,
        },
        top: "1",
        bottom: "dndnode_1",
      },
    },
    {
      id: "dndnode_1",
      data: { label: "Delay" },
      BackendData: {
        data: { count: 1, type: "Days" },
        top: "dndnode_0",
        bottom: "",
      },
    },
  ]);
  const handleCreateListInDrawerComponent = () => {
    return (
      <Drawer
        placement={"right"}
        open={openDrawerForCreateList}
        onClose={() => setOpenDrawerForCreateList(false)}
        size="md"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            style={{
              padding: "10px 16px",
              borderBottom: "1px solid #DDD",
              flexShrink: 0,
            }}
          >
            <p
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
                color: "#4B4B4B",
              }}
            >
              Create a new list
            </p>
          </div>
          <div
            style={{
              flexGrow: 1,
              overflowY: "scroll",
              backgroundColor: "#FFF",
              padding: "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <ImportOptionsCopy closingFun={handleCloseDrawer} />
          </div>
          {/* <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-start",
              borderTop: "1px solid #DDD",
              flexShrink: 0,
              padding: "10px 16px",
            }}
          >
            <div
              onClick={() => setOpenDrawerForCreateList(false)}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#1C485F",
                backgroundColor: "#D1DFE9",
                border: "1px solid #1C485F",
                borderRadius: "6px",
                padding: "6px 24px",
                cursor: "pointer",
              }}
            >
              Cancel
            </div>
          </div> */}
        </div>
      </Drawer>
    );
  };
  const handleChange = (event) => {
    setWaiting(event.target.value);
  };

  const handleChangesss = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      setTimeLimit(inputValue);
      setIsValid(inputValue === "" || /^(2[0-9]|[2-9]|1[0-9]|30)$/.test(inputValue));
    }
  };
  useEffect(() => {
    setAllNodes(nodes);
  }, [nodes]);

  useEffect(() => {
    setAllEdges(edges);
  }, [edges]);

  const handleChange5 = (event) => {
    setWaitingDelay(event.target.value);
  };
  function setLocalStorageData() {
    let nodeData = {
      id: Math.floor(10000 + Math.random() * 90000),
      createdDate: getFormattedDateTime(),
      selectedSchedule: selectedSchedule,

      fromEmail: accountList,
      // name list selecedfrom the contact
      //nameListObj._id
      //toData:nameList._id ,
      structure: locData.state.isEnableSequence ? sequenceData : nodes,
      edges: edges,
      allContact: emailType,
      timeGap: timeLimit,
      sentStrategy: abTestingStratergy,
      missingVariable: checkType,
      nameListId: nameListObject,
      name: locData.state.campaignName,
      sendOption: emailRiskType,
      enable: enable,
      ccEmail: ccEmails,
      bccEmail: bccEmails,
      bccStatus:bccStatus,
      abTesting: abTestingStatus,
      abTestingOptimize: abTestingWin,
      sequence: locData.state.isEnableSequence,
      duration: {
        Status: campDuration,
        CountryDateTime: countryTimeSchedule2,
        StartDate: campStartDate,
        EndDate: campEndDate,
      },
    };
    if (locData.state.from !== "edit") {
      console.log("saved");
      localStorage.setItem("draftedcampaigndata", JSON.stringify(nodeData));
    }

    return nodeData;
  }
  function saveLocalStorageData() {
    let nodeData = {
      id: Math.floor(10000 + Math.random() * 90000),
      createdDate: getFormattedDateTime(),
      selectedSchedule: selectedSchedule,

      fromEmail: accountList,
      // name list selecedfrom the contact
      //nameListObj._id
      //toData:nameList._id ,
      structure: locData.state.isEnableSequence ? sequenceData : nodes,
      edges: edges,
      allContact: emailType,
      timeGap: timeLimit,
      sentStrategy: abTestingStratergy,
      missingVariable: checkType,
      nameListId: nameListObject,
      name: locData.state.campaignName,
      sendOption: emailRiskType,
      enable: enable,
      ccEmail: ccEmails,
      bccEmail: bccEmails,
      abTesting: abTestingStatus,
      abTestingOptimize: abTestingWin,
      sequence: locData.state.isEnableSequence,
      duration: {
        Status: campDuration,
        CountryDateTime: countryTimeSchedule2,
        StartDate: campStartDate,
        EndDate: campEndDate,
      },
    };
    return nodeData;
  }

  function getFormattedDateTime() {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const today = new Date();

    const day = today.getDate().toString().padStart(2, "0");
    const month = months[today.getMonth()];
    const year = today.getFullYear();
    let hours = today.getHours();
    const minutes = today.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    if (hours > 12) {
      hours -= 12;
    }

    const formattedDateTime = `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
    return formattedDateTime;
  }
  useEffect(() => {
    let campaignDraftedData = JSON.parse(
      localStorage.getItem("draftedcampaigndata")
    );
    if (locData.state !== undefined) {
      if (locData.state.from === "draft") {
        campaignDraftedData.structure.map((val, idx) => {
          if (idx === 0) {
            val.data.handleEvent2 = handleCustomNodeEvent2;
          } else {
            val.data.handleEvent = handleCustomNodeEvent;
          }
        });
        setAbTestingStratergy(campaignDraftedData.sentStrategy);

        if (!locData.state.isEnableSequence) {
          setNodes(campaignDraftedData.structure);
        } else {
          setSequenceData(campaignDraftedData.structure);
        }

        setEdges(campaignDraftedData.edges);

        setNameListObject(campaignDraftedData.nameListId);
        let varArr = [];
        if (campaignDraftedData.nameListId.length !== 0) {
          setNameList(campaignDraftedData.nameListId.Name);
          setNameListId(campaignDraftedData.nameListId._id);
          setCCEmails(campaignDraftedData.ccEmail);
          setBccEmails(campaignDraftedData.bccEmail);
          setBccStatus(campaignDraftedData.bccStatus)
          setABTestingStatus(campaignDraftedData.abTesting);
          setAbTestingWin(campaignDraftedData.abTestingOptimize);
          console.log("vikki draft", campaignDraftedData);
          if (campaignDraftedData.nameListId.Contact[0].FirstName !== "") {
            varArr.push("First Name");
          }
          if (campaignDraftedData.nameListId.Contact[0].LastName !== "") {
            varArr.push("Last Name");
          }
          if (campaignDraftedData.nameListId.Contact[0].Email !== "") {
            varArr.push("Email");
          }
          if (campaignDraftedData.nameListId.Contact[0].Phone !== "") {
            varArr.push("Phone Number");
          }
          if (campaignDraftedData.nameListId.Contact[0].CompanyName !== "") {
            varArr.push("Company Name");
          }
          if (campaignDraftedData.nameListId.Contact[0].Website !== "") {
            varArr.push("Website");
          }
          setVariableArray(varArr);
        }

        setEmailType(campaignDraftedData.allContact);
        setEmailRiskType(campaignDraftedData.sendOption);
        setCheckType(campaignDraftedData.missingVariable);
        setAccountList(campaignDraftedData.fromEmail);
        setTimeLimit(campaignDraftedData.timeGap);
        setSelectedSchedule(campaignDraftedData.selectedSchedule);
        setEnable(campaignDraftedData.enable);
        setCampDuration(campaignDraftedData.duration.Status);

        setCountryTimeSchdule2(campaignDraftedData.duration.CountryDateTime);
      } else if (locData.state.from === "edit") {
        locData.state.campaignData.structure.map((val, idx) => {
          if (idx === 0) {
            val.data.handleEvent2 = handleCustomNodeEvent2;
          } else {
            val.data.handleEvent = handleCustomNodeEvent;
          }
        });
        setAbTestingStratergy(locData.state.campaignData.sentStrategy);
        if (!locData.state.isEnableSequence) {
          setNodes(locData.state.campaignData.structure);
        } else {
          
          setSequenceData(locData.state.campaignData.structure);
        }

        setEdges(locData.state.campaignData.edges);
        setNameListObject(locData.state.campaignData.nameListId);
        let varArr = [];
        if (locData.state.campaignData.nameListId.length !== 0) {
          setNameList(locData.state.campaignData.nameListId.Name);
          setNameListId(locData.state.campaignData.nameListId._id);
          console.log("vikki edit", locData.state);
          if (
            locData.state.campaignData?.nameListId?.Contact[0]?.FirstName !== ""
          ) {
            varArr.push("First Name");
          }
          if (
            locData.state.campaignData?.nameListId?.Contact[0].LastName !== ""
          ) {
            varArr.push("Last Name");
          }
          if (locData.state.campaignData?.nameListId?.Contact[0].Email !== "") {
            varArr.push("Email");
          }
          if (locData.state.campaignData?.nameListId?.Contact[0].Phone !== "") {
            varArr.push("Phone Number");
          }
          if (
            locData.state.campaignData?.nameListId?.Contact[0].CompanyName !==
            ""
          ) {
            varArr.push("Company Name");
          }
          if (
            locData.state.campaignData?.nameListId?.Contact[0].Website !== ""
          ) {
            varArr.push("Website");
          }
          setVariableArray(varArr);
        }

        setEmailType(locData.state.campaignData?.allContact);
        setEmailRiskType(locData.state.campaignData?.sendOption);
        setCheckType(locData.state.campaignData?.missingVariable);
        setAccountList(locData.state.campaignData?.fromEmail);
        setTimeLimit(locData.state.campaignData?.timeGap);
        setSelectedSchedule(locData.state.campaignData?.selectedSchedule);
        setEnable(locData.state.campaignData?.enable);
        setCCEmails(locData.state.campaignData?.ccEmail);
        setBccStatus(locData.state.campaignData?.bccStatus)
        setBccEmails(locData.state.campaignData?.bccEmail);
        setABTestingStatus(locData.state.campaignData?.abTesting);
        setAbTestingWin(locData.state.campaignData?.abTestingOptimize);
        setCampDuration(locData.state.campaignData?.duration.Status);
        
        setCountryTimeSchdule2(
          locData.state.campaignData?.duration.CountryDateTime
        );
      }
    }
    getShceduleData();
  }, []);
  const handleChange6 = (event) => {
    if (event.target.value !== undefined) {
      setNameList(event.target.value.Name);
      setNameListId(event.target.value._id);
      setNameListObject(event.target.value);
      let varArr = [];
      if (event.target.value.SampleContact.FirstName !== "") {
        varArr.push("First Name");
        
      }
      if (event.target.value.SampleContact.LastName !== "") {
        varArr.push("Last Name");
      }
      if (event.target.value.SampleContact.Email !== "") {
        varArr.push("Email");
      }
      if (event.target.value.SampleContact.Phone !== "") {
        varArr.push("Phone Number");
      }
      if (event.target.value.SampleContact.CompanyName !== "") {
        varArr.push("Company Name");
      }
      if (event.target.value.SampleContact.Website !== "") {
        varArr.push("Website");
      }
      setVariableArray(varArr);
    } else {
      setOpenDrawerForCreateList(true);
    }
  };
  const handleChange9 = (event, newValue) => {
    setCountryTimeSchdule(newValue);
  };
  const handleChange8 = (event) => {
    // console.log("fjfjfjjfj", event.target.value);
    setAccountList(event.target.value);
  };
  const handleChange7 = (event) => {
    setNoNameList(event.target.value);
  };
  const handleChange3 = (event) => {
    setFromTime(event.target.value);
  };
  const handleChange4 = (event) => {
    setToTime(event.target.value);
  };
  const handleChange2 = (event) => {
    setTimingZone(event.target.value);
  };
  const edgeTypes = {
    custom: customEdgeStyles,
  };
  useEffect(() => {
    getAllNameList();
  }, []);
  function getAllNameList() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/contact/get-all-name-list/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setNameListArr(response.data.details);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setListLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  const onConnect = useCallback(
    (params, from) => {
      const { source, target } = params;
      if (from !== undefined) {
        const newEdge = {
          id: `edge-${source}-${target}`,
          source: target,
          target: source,
          // animated: true,
          // style: { stroke: "#1C485F" },
          style: {
            strokeWidth: "4px",
            stroke: "var(--color-dark-300, #B0B0B0)",
          },
        };
        setEdges((prevEdges) => [...prevEdges, newEdge]);
      } else {
        let nodeLabel = false;
        nodes.map((val) => {
          if (val.id === source || val.id === target) {
            if (val.data.label === "Trigger") {
              nodeLabel = true;
            }
          }
        });
        if (nodeLabel) {
          if (edges.some((obj) => obj.target === target)) {
            return;
          } else {
            const edgeAExists = edges.some(
              (obj) =>
                obj.id.split("-")[1] === `${source}a` ||
                obj.id.split("-")[2] === target
            );
            const edgeBExists = edges.some(
              (obj) =>
                obj.id.split("-")[1] === `${source}b` ||
                obj.id.split("-")[2] === target
            );
            if (edgeAExists && edgeBExists) {
              return;
            } else {
              if (!edgeAExists && edgeBExists) {
                const newEdge = {
                  id: `edge-${source}a-${target}`,
                  source: source,
                  target: target,
                  style: {
                    strokeWidth: "4px",
                    stroke: "var(--color-dark-300, #B0B0B0)",
                  },
                  sourceHandle: "a",
                };
                setEdges((prevEdges) => [...prevEdges, newEdge]);
              } else if (!edgeAExists && !edgeBExists) {
                const newEdge = {
                  id: `edge-${source}a-${target}`,
                  source: source,
                  target: target,
                  style: {
                    strokeWidth: "4px",
                    stroke: "var(--color-dark-300, #B0B0B0)",
                  },
                  sourceHandle: "a",
                };
                setEdges((prevEdges) => [...prevEdges, newEdge]);
              } else if (edgeAExists && !edgeBExists) {
                const newEdge = {
                  id: `edge-${source}b-${target}`,
                  source: source,
                  target: target,
                  style: {
                    strokeWidth: "4px",
                    stroke: "var(--color-dark-300, #B0B0B0)",
                  },
                  sourceHandle: "b",
                };
                setEdges((prevEdges) => [...prevEdges, newEdge]);
              }
            }
          }
        } else {
          const newEdge = {
            id: `edge-${source}-${target}`,
            source: source,
            target: target,
            // animated: true,
            // style: { stroke: "#1C485F" },
            style: {
              strokeWidth: "4px",
              stroke: "var(--color-dark-300, #B0B0B0)",
            },
          };
          setEdges((prevEdges) => [...prevEdges, newEdge]);
        }
      }
    },
    [nodes]
  );

  const onDragOver = useCallback(
    (event) => {
      event.preventDefault();
      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData("application/reactflow");
      // Check if the dropped element is valid
      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      // Create a new node with the dropped type
      if (type === "Trigger") {
        const newNode = {
          id: getId(),
          type: "custom", // Set the type based on the dropped element
          position,
          data: { label: `${type}`, handleEvent: handleCustomNodeEvent },
        };
        setNodes((prevNodes) => [...prevNodes, newNode]);
      } else {
        const newNode = {
          id: getId(),
          type: "custom", // Set the type based on the dropped element
          position,
          data: { label: `${type}`, handleEvent: handleCustomNodeEvent },
        };
        // onDrag("", newNode);

        setNodes((prevNodes) => [...prevNodes, newNode]);
      }
    },
    [reactFlowInstance, nodes, setNodes, setEdges]
  );
  const handleCustomNodeEvent = useCallback(
    (allNode, node, allEdge, type, modal, triggType) => {
      if (modal) {
        if (triggType !== undefined) {
          setTriggSideType(triggType);
        }
        setOpen5(true);
        setSelPosition(node);
      } else {
        if (type === "delete") {
          // Do something with the event data
          allNode.map((val, idx) => {
            if (val.id === node.id) {
              allNode.splice(idx, 1);
            }
          });

          const uniqueArrayOfObjects = allEdge.filter(
            (obj, index, self) =>
              index === self.findIndex((o) => o.id === obj.id)
          );
          const arrObj = uniqueArrayOfObjects.filter(
            (obj) => obj.source !== node.id
          );
          const arrObj2 = arrObj.filter((obj) => obj.target !== node.id);
          setEdges([]);
          setTimeout(() => {
            setEdges(arrObj2);
          }, 50);
          setNodes(allNode);
        } else {
          if (node.data.label !== "Start") {
            allNode.map((val) => {
              if (node.id === val.id) {
                if (val.BackendData !== undefined) {
                  if (val.data.label === "email") {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(
                      val.BackendData.data.body,
                      "text/html"
                    );
                    const spans = doc.querySelectorAll("span.clickable-span");
                    spans.forEach((span) => {
                      span.style.color = "red";
                      span.style.display = "inline";
                      span.style.padding = "4px 14px";
                      span.style.width = "auto";
                      span.style.justifyContent = "center";
                      span.style.alignItems = "center";
                      span.style.gap = "10px";
                      span.style.borderRadius = "4px";
                      span.style.border =
                        "1px solid var(--color-primary, #1C485F)";
                      span.style.color = "var(--color-primary, #1C485F)";
                      span.style.textAlign = "center";
                      span.style.fontFamily = "Source Sans 3";
                      span.style.whiteSpace = "nowrap";
                      span.style.fontSize = "14px";
                      span.style.fontStyle = "normal";
                      span.style.fontWeight = "400";
                      span.style.lineHeight = "20px";
                      span.style.cursor = "pointer"; // Add your style properties here
                      // Add more styles if needed
                    });
                    const modifiedHtml = doc.body.innerHTML;
                    /////
                    const docB = parser.parseFromString(
                      val.BackendData.data.bodyB,
                      "text/html"
                    );
                    const spansB = docB.querySelectorAll("span.clickable-span");
                    spansB.forEach((span) => {
                      span.style.color = "red";
                      span.style.display = "inline";
                      span.style.padding = "4px 14px";
                      span.style.width = "auto";
                      span.style.justifyContent = "center";
                      span.style.alignItems = "center";
                      span.style.gap = "10px";
                      span.style.borderRadius = "4px";
                      span.style.border =
                        "1px solid var(--color-primary, #1C485F)";
                      span.style.color = "var(--color-primary, #1C485F)";
                      span.style.textAlign = "center";
                      span.style.fontFamily = "Source Sans 3";
                      span.style.whiteSpace = "nowrap";
                      span.style.fontSize = "14px";
                      span.style.fontStyle = "normal";
                      span.style.fontWeight = "400";
                      span.style.lineHeight = "20px";
                      span.style.cursor = "pointer"; // Add your style properties here
                      // Add more styles if needed
                    });
                    const modifiedHtmlB = docB.body.innerHTML;
                    ///
                    const docSubject = parser.parseFromString(
                      val.BackendData.data.subject,
                      "text/html"
                    );
                    const spansSubject = docSubject.querySelectorAll("span.clickable-span");
                    spansSubject.forEach((span) => {
                      span.style.color = "red";
                      span.style.display = "inline";
                      span.style.padding = "4px 14px";
                      span.style.width = "auto";
                      span.style.justifyContent = "center";
                      span.style.alignItems = "center";
                      span.style.gap = "10px";
                      span.style.borderRadius = "4px";
                      span.style.border =
                        "1px solid var(--color-primary, #1C485F)";
                      span.style.color = "var(--color-primary, #1C485F)";
                      span.style.textAlign = "center";
                      span.style.fontFamily = "Source Sans 3";
                      span.style.whiteSpace = "nowrap";
                      span.style.fontSize = "14px";
                      span.style.fontStyle = "normal";
                      span.style.fontWeight = "400";
                      span.style.lineHeight = "20px";
                      span.style.cursor = "pointer"; 
                    });
                    const modifiedHtmlSubject = docSubject.body.innerHTML;
                    const docSubjectB = parser.parseFromString(
                      val.BackendData.data.subjectB,
                      "text/html"
                    );
                    const spansSubjectB = docSubjectB.querySelectorAll("span.clickable-span");
                    spansSubjectB.forEach((span) => {
                      span.style.color = "red";
                      span.style.display = "inline";
                      span.style.padding = "4px 14px";
                      span.style.width = "auto";
                      span.style.justifyContent = "center";
                      span.style.alignItems = "center";
                      span.style.gap = "10px";
                      span.style.borderRadius = "4px";
                      span.style.border =
                        "1px solid var(--color-primary, #1C485F)";
                      span.style.color = "var(--color-primary, #1C485F)";
                      span.style.textAlign = "center";
                      span.style.fontFamily = "Source Sans 3";
                      span.style.whiteSpace = "nowrap";
                      span.style.fontSize = "14px";
                      span.style.fontStyle = "normal";
                      span.style.fontWeight = "400";
                      span.style.lineHeight = "20px";
                      span.style.cursor = "pointer"; 
                    });
                    const modifiedHtmlSubjectB = docSubjectB.body.innerHTML;
                    setABTestingStatus(val.BackendData.data.ABTesting);
                    setSubject(modifiedHtmlSubject);
                    setEmailBody(modifiedHtml);
                    setSubjectB(modifiedHtmlSubjectB);
                    setEmailBodyB(modifiedHtmlB);
                  }
                  if (val.data.label === "Trigger") {
                    setTriggerValue(val.BackendData.data.trigger);
                    setCount(val.BackendData.data.waitingTime.count);
                    setWaiting(val.BackendData.data.waitingTime.type);
                  }
                  if (val.data.label === "Delay") {
                    setCount1(val.BackendData.data.count);
                    setWaitingDelay(val.BackendData.data.type);
                  }
                  if (val.data.label === "Goal") {
                    setGoalName(val.BackendData.data.goalName);
                  }
                } else {
                  setSubject("");
                  setBody("");
                  setEmailBody("");
                  setSubjectB("");
                  setEmailBodyB("");
                  setCount(1);
                  setWaiting("Days");
                  setCount1(1);
                  setWaitingDelay("Days");
                  setGoalName("");
                  setABTestingStatus(false);
                }
              }
            });

            setSelected(node.data.label);
            setSelectedId(node.id);
            // 'node' contains information about the clicked node
            setOpen3(true);
            const uniqueArrayOfObjects = allEdge.filter(
              (obj, index, self) =>
                index === self.findIndex((o) => o.id === obj.id)
            );
            setEdges(uniqueArrayOfObjects);
          }
        }
      }
    },
    [edges, nodes]
  );
  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData("application/reactflow");

      // Check if the dropped element is valid
      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      // Create a new node with the dropped type
      if (type === "Trigger") {
        const newNode = {
          id: getId(),
          type: "custom", // Set the type based on the dropped element
          position,
          data: { label: `${type}`, handleEvent: handleCustomNodeEvent },
        };

        setNodes((prevNodes) => [...prevNodes, newNode]);
      } else {
        const newNode = {
          id: getId(),
          type: "custom", // Set the type based on the dropped element
          position,
          data: { label: `${type}`, handleEvent: handleCustomNodeEvent },
        };

        setNodes((prevNodes) => [...prevNodes, newNode]);
      }
    },
    [reactFlowInstance, nodes, setNodes, setEdges]
  );
  const onDragStart = useCallback(
    (event, nodeType, node) => {
      setOpen5(false);
      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();

      // Check if the dropped element is valid
      if (typeof nodeType === "undefined" || !nodeType) {
        return;
      }

      // Create a new node with the dropped type

      if (selPosition.data.label === "Trigger") {
        if (triggSideType === "a") {
          const position = {
            x: selPosition.xPos - 150,
            y: selPosition.yPos + 160,
          };
          const newNode = {
            id: getId(),
            type: "custom", // Set the type based on the dropped element
            position,
            data: { label: `${nodeType}`, handleEvent: handleCustomNodeEvent },
          };

          const newEdge = {
            id: `edge-${selPosition.id}a-${newNode.id}`,
            source: selPosition.id,
            target: newNode.id,
            style: {
              strokeWidth: "4px",
              stroke: "var(--color-dark-300, #B0B0B0)",
            },
            sourceHandle: "a",
          };
          setEdges((prevEdges) => [...prevEdges, newEdge]);
          setNodes((prevNodes) => [...prevNodes, newNode]);
        } else {
          const position = {
            x: selPosition.xPos + 150,
            y: selPosition.yPos + 160,
          };
          const newNode = {
            id: getId(),
            type: "custom", // Set the type based on the dropped element
            position,
            data: { label: `${nodeType}`, handleEvent: handleCustomNodeEvent },
          };

          const newEdge = {
            id: `edge-${selPosition.id}b-${newNode.id}`,
            source: selPosition.id,
            target: newNode.id,
            style: {
              strokeWidth: "4px",
              stroke: "var(--color-dark-300, #B0B0B0)",
            },
            sourceHandle: "b",
          };
          setEdges((prevEdges) => [...prevEdges, newEdge]);
          setNodes((prevNodes) => [...prevNodes, newNode]);
        }
      } else {
        const position = {
          x:
            selPosition.data.label === "Start"
              ? selPosition.xPos - 68
              : selPosition.xPos,
          y:
            selPosition.data.label === "Start"
              ? selPosition.yPos + 100
              : selPosition.yPos + 130,
        };
        const newNode = {
          id: getId(),
          type: "custom", // Set the type based on the dropped element
          position,
          data: { label: `${nodeType}`, handleEvent: handleCustomNodeEvent },
        };
        setNodes((prevNodes) => [...prevNodes, newNode]);
        onConnect(
          {
            source: newNode.id,
            target: selPosition.id,
            animated: true, // You can  customize this option
          },
          "drag"
        );
      }
    },
    [edges, nodes, selPosition]
  );
  // const onDrag = (event, node) => {
  //   const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
  //   const sourceNode = node;
  //   const minDistance = 200; // Adjust this as needed
  //   //     const uniqueArrayOfObjects = edges.filter((obj, index, self) =>
  //   //   index === self.findIndex((o) => o.source === obj.source)
  //   // );
  //   // setEdges(uniqueArrayOfObjects)
  //   if (sourceNode.data.label === "email") {
  //     nodes.forEach((targetNode) => {
  //       if (
  //         sourceNode.id !== targetNode.id &&
  //         (targetNode.data.label === "Start" ||
  //           targetNode.data.label === "Trigger" ||
  //           targetNode.data.label === "Delay" ||
  //           targetNode.data.label === "email")
  //       ) {
  //         const sourceNodePosition = sourceNode.position;
  //         const targetNodePosition = targetNode.position;

  //         // Calculate the distance between the nodes
  //         const distance = Math.sqrt(
  //           Math.pow(targetNodePosition.x - sourceNodePosition.x, 2) +
  //             Math.pow(targetNodePosition.y - sourceNodePosition.y, 2)
  //         );

  //         if (distance < minDistance) {
  //           if (targetNode.data.label === "Trigger") {
  //             if (edges.some((obj) => obj.target === sourceNode.id)) {
  //               return;
  //             } else {
  //               const edgeAExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}a` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               const edgeBExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}b` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               if (edgeAExists && edgeBExists) {
  //                 return;
  //               } else {
  //                 if (!edgeAExists && edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (!edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}b-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "b",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 }
  //               }
  //             }
  //           } else {
  //             if (edges.length === 0) {
  //               onConnect(
  //                 {
  //                   source: sourceNode.id,
  //                   target: targetNode.id,
  //                   animated: true, // You can customize this option
  //                 },
  //                 "drag"
  //               );
  //             } else {
  //               if (
  //                 edges.some((obj) => {
  //                   return (
  //                     obj.source === targetNode.id ||
  //                     // sourceNode.id.split("_")[1] <
  //                     //   targetNode.id.split("_")[1]||
  //                     obj.target === sourceNode.id
  //                   );
  //                 })
  //               ) {
  //                 return null;
  //               } else {
  //                 onConnect(
  //                   {
  //                     source: sourceNode.id,
  //                     target: targetNode.id,
  //                     animated: true, // You can customize this option
  //                   },
  //                   "drag"
  //                 );
  //               }
  //             }
  //           }
  //         }
  //       }
  //     });
  //   }
  //   if (sourceNode.data.label === "Trigger") {
  //     nodes.forEach((targetNode) => {
  //       if (
  //         sourceNode.id !== targetNode.id &&
  //         (targetNode.data.label === "email" ||
  //           targetNode.data.label === "Trigger" ||
  //           targetNode.data.label === "Delay" ||
  //           targetNode.data.label === "Goal")
  //       ) {
  //         const sourceNodePosition = sourceNode.position;
  //         const targetNodePosition = targetNode.position;

  //         // Calculate the distance between the nodes
  //         const distance = Math.sqrt(
  //           Math.pow(targetNodePosition.x - sourceNodePosition.x, 2) +
  //             Math.pow(targetNodePosition.y - sourceNodePosition.y, 2)
  //         );

  //         if (distance < minDistance) {
  //           if (targetNode.data.label === "Trigger") {
  //             if (edges.some((obj) => obj.target === sourceNode.id)) {
  //               return;
  //             } else {
  //               const edgeAExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}a` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               const edgeBExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}b` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               if (edgeAExists && edgeBExists) {
  //                 return;
  //               } else {
  //                 if (!edgeAExists && edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (!edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}b-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "b",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 }
  //               }
  //             }
  //           } else if (
  //             edges.some(
  //               (obj) =>
  //                 obj.source === targetNode.id ||
  //                 // sourceNode.id.split("_")[1] < targetNode.id.split("_")[1] ||
  //                 obj.target === sourceNode.id
  //             )
  //           ) {
  //             return;
  //           } else {
  //             onConnect(
  //               {
  //                 source: sourceNode.id,
  //                 target: targetNode.id,
  //                 animated: true, // You can customize this option
  //               },
  //               "drag"
  //             );
  //           }
  //         }
  //       } else {
  //         setOpen2(true);
  //         setNodeErrorMessage(
  //           "You can only add a trigger after an email or another trigger."
  //         );
  //       }
  //     });
  //   }
  //   if (sourceNode.data.label === "Delay") {
  //     nodes.forEach((targetNode) => {
  //       if (
  //         sourceNode.id !== targetNode.id &&
  //         (targetNode.data.label === "email" ||
  //           targetNode.data.label === "Delay" ||
  //           targetNode.data.label === "Trigger" ||
  //           targetNode.data.label === "Goal")
  //       ) {
  //         const sourceNodePosition = sourceNode.position;
  //         const targetNodePosition = targetNode.position;

  //         // Calculate the distance between the nodes
  //         const distance = Math.sqrt(
  //           Math.pow(targetNodePosition.x - sourceNodePosition.x, 2) +
  //             Math.pow(targetNodePosition.y - sourceNodePosition.y, 2)
  //         );

  //         if (distance < minDistance) {
  //           if (targetNode.data.label === "Trigger") {
  //             if (edges.some((obj) => obj.target === sourceNode.id)) {
  //               return;
  //             } else {
  //               const edgeAExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}a` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               const edgeBExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}b` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               if (edgeAExists && edgeBExists) {
  //                 return;
  //               } else {
  //                 if (!edgeAExists && edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (!edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}b-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "b",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 }
  //               }
  //             }
  //           } else {
  //             if (
  //               edges.some(
  //                 (obj) =>
  //                   obj.source === targetNode.id ||
  //                   // sourceNode.id.split("_")[1] < targetNode.id.split("_")[1] ||
  //                   obj.target === sourceNode.id
  //               )
  //             ) {
  //               return;
  //             } else {
  //               onConnect(
  //                 {
  //                   source: sourceNode.id,
  //                   target: targetNode.id,
  //                   animated: true, // You can customize this option
  //                 },
  //                 "drag"
  //               );
  //             }
  //           }
  //         }
  //       }
  //     });
  //   }
  //   if (sourceNode.data.label === "Goal") {
  //     nodes.forEach((targetNode) => {
  //       if (
  //         sourceNode.id !== targetNode.id &&
  //         (targetNode.data.label === "email" ||
  //           targetNode.data.label === "Trigger" ||
  //           targetNode.data.label === "Delay")
  //       ) {
  //         const sourceNodePosition = sourceNode.position;
  //         const targetNodePosition = targetNode.position;

  //         // Calculate the distance between the nodes
  //         const distance = Math.sqrt(
  //           Math.pow(targetNodePosition.x - sourceNodePosition.x, 2) +
  //             Math.pow(targetNodePosition.y - sourceNodePosition.y, 2)
  //         );

  //         if (distance < minDistance) {
  //           if (targetNode.data.label === "Trigger") {
  //             if (edges.some((obj) => obj.target === sourceNode.id)) {
  //               return;
  //             } else {
  //               const edgeAExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}a` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               const edgeBExists = edges.some(
  //                 (obj) =>
  //                   obj.id.split("-")[1] === `${targetNode.id}b` ||
  //                   obj.id.split("-")[2] === sourceNode.id
  //               );
  //               if (edgeAExists && edgeBExists) {
  //                 return;
  //               } else {
  //                 if (!edgeAExists && edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (!edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}a-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "a",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 } else if (edgeAExists && !edgeBExists) {
  //                   const newEdge = {
  //                     id: `edge-${targetNode.id}b-${sourceNode.id}`,
  //                     source: targetNode.id,
  //                     target: sourceNode.id,
  //                     style: {
  //                       strokeWidth: "4px",
  //                       stroke: "var(--color-dark-300, #B0B0B0)",
  //                     },
  //                     sourceHandle: "b",
  //                   };
  //                   setEdges((prevEdges) => [...prevEdges, newEdge]);
  //                 }
  //               }
  //             }
  //           } else {
  //             if (
  //               edges.some(
  //                 (obj) =>
  //                   obj.source === targetNode.id ||
  //                   // sourceNode.id.split("_")[1] < targetNode.id.split("_")[1] ||
  //                   obj.target === sourceNode.id
  //               )
  //             ) {
  //               return;
  //             } else {
  //               onConnect(
  //                 {
  //                   source: sourceNode.id,
  //                   target: targetNode.id,
  //                   animated: true, // You can customize this option
  //                 },
  //                 "drag"
  //               );
  //             }
  //           }
  //         }
  //       }
  //     });
  //   }
  // };
  // const onNodeDrag = (event, node) => {
  //   const sourceNode = node;
  //   const minDistance = 300; // Adjust this as needed
  //   let newEdges = [];
  //   if (sourceNode.data.label === "email") {
  //     nodes.forEach((targetNode) => {
  //       if (
  //         sourceNode.id !== targetNode.id &&
  //         targetNode.data.label === "Start"
  //       ) {
  //         const sourceNodePosition = sourceNode.position;
  //         const targetNodePosition = targetNode.position;

  //         // Calculate the distance between the nodes
  //         const distance = Math.sqrt(
  //           Math.pow(targetNodePosition.x - sourceNodePosition.x, 2) +
  //             Math.pow(targetNodePosition.y - sourceNodePosition.y, 2)
  //         );

  //         // Check if the nodes are close enough to display the edge
  //         if (distance < minDistance) {
  //           // Update the edge position dynamically
  //           const newEdge = {
  //             id: `edge-${sourceNode.id}-${targetNode.id}`,
  //             source: targetNode.id,
  //             target: sourceNode.id,
  //             animated: true,
  //             style: { stroke: "#1C485F" }, // You can customize the edge's style
  //           };

  //           newEdges.push(newEdge);
  //         }
  //       }
  //     });
  //     setEdges(newEdges);
  //   }
  // };
  const onEdgeClick = (event, edge) => {
    setSelectedEdge(edge);
    setModalPosition({ x: event.clientX, y: event.clientY });
    setIsModalOpen(true);
  };
  const onNodeDrop = (event, node) => {};
  // const handleNodeClick = (event, node) => {
  //   console.log("clicked node",node)

  // };
  const handleNodeMouseEnter = (event, node) => {
    handleCloseModal();
    setHoveredNode(node);
  };
  const handleNodeMouseLeave = (event) => {
    // setHoveredNode([]);
  };
  function createEmailForNode() {
    const htmlString = emailBody;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const spans = doc.querySelectorAll("span.clickable-span");
    spans.forEach((span) => span.removeAttribute("style"));
    const modifiedHtml = doc.body.innerHTML;
    /////
    const htmlStringB = emailBodyB;
    const docB = parser.parseFromString(htmlStringB, "text/html");
    const spansB = docB.querySelectorAll("span.clickable-span");
    spansB.forEach((span) => span.removeAttribute("style"));
    const modifiedHtmlB = docB.body.innerHTML;
    
    const htmlStringSubject = subject;
    const docSubject = parser.parseFromString(htmlStringSubject, "text/html");
    const spansSubject = docSubject.querySelectorAll("span.clickable-span");
    spansSubject.forEach((span) => span.removeAttribute("style"));
    const modifiedHtmlSubject = docSubject.body.innerHTML;

    const htmlStringBSubject = subjectB;
    const docBSubject = parser.parseFromString(htmlStringBSubject, "text/html");
    const spansBSubject = docBSubject.querySelectorAll("span.clickable-span");
    spansBSubject.forEach((span) => span.removeAttribute("style"));
    const modifiedHtmlBSubject = docBSubject.body.innerHTML;

    let emailData = {
      ABTesting: abTestingStatus,
      subject:  [
        ReactDOMServer.renderToString(modifiedHtmlSubject).slice(0, 0),
        modifiedHtmlSubject.slice(0),
        `<br></br>`,
      ].join(""),
      // body: ReactDOMServer.renderToString(<GreetingEmail />),
      body: [
        ReactDOMServer.renderToString(modifiedHtml).slice(0, 0),
        modifiedHtml.slice(0),
        ``,
      ].join(""),
      subjectA: [
        ReactDOMServer.renderToString(modifiedHtmlSubject).slice(0, 0),
        modifiedHtmlSubject.slice(0),
        ``,
      ].join(""),
      bodyA: [
        ReactDOMServer.renderToString(modifiedHtml).slice(0, 0),
        modifiedHtml.slice(0),
        ``,
      ].join(""),
      subjectB: [
        ReactDOMServer.renderToString(modifiedHtmlBSubject).slice(0, 0),
        modifiedHtmlBSubject.slice(0),
        ``,
      ].join(""),
      bodyB: [
        ReactDOMServer.renderToString(modifiedHtmlB).slice(0, 0),
        modifiedHtmlB.slice(0),
        ``,
      ].join(""),
    };
    console.log("emaildata backend", emailData);
    nodes.map((val) => {
      if (val.id === selectedId) {
        val.BackendData = {
          data: emailData,
        };
      }
    });
    setNodes([...nodes]);
    setOpen3(false);
  }
  function createTriggerValue() {
    let triggerData = {
      trigger: triggerValue,
      waitingTime: {
        count: count,
        type: waiting,
      },
      // schedule:{
      //   days:selectedDays
      // },
      // countryTiming:timingZone,
      // fromTime:fromTime,
      // toTime:toTime
    };

    nodes.map((val) => {
      if (val.id === selectedId) {
        val.BackendData = {
          data: triggerData,
        };
      }
    });
    setNodes([...nodes]);
    setOpen3(false);
  }
  function createDelayvalues() {
    let delayData = {
      count: count1,
      type: waitingDelay,
    };
    nodes.map((val) => {
      if (val.id === selectedId) {
        val.BackendData = {
          data: delayData,
        };
      }
    });
    setNodes([...nodes]);
    setOpen3(false);
  }
  function createGoalValues() {
    let goalData = {
      goalName: goalName,
    };
    nodes.map((val) => {
      if (val.id === selectedId) {
        val.BackendData = {
          data: goalData,
        };
      }
    });
    setNodes([...nodes]);
    setOpen3(false);
  }
  function isValidEmail(email) {
    // Regular expression pattern for a basic email validation
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Test the email against the pattern
    return emailPattern.test(email);
  }
  function sendDataBackend() {
    if (!locData.state.isEnableSequence) {
      nodes.map((val, idx) => {
        if (idx === 0) {
          val.BackendData.bottom = nodes[idx + 1].id;
        }
        let top, bottom;
        let bottomArray = [];
        if (val.BackendData !== undefined && idx !== 0) {
          edges.map((edge) => {
            if (val.data.label === "Trigger") {
              if (edge.source === val.id) {
                bottomArray.push({
                  Edge: edge.target,
                  Target: edge.sourceHandle === "a" ? "no" : "yes",
                });
              }
              if (edge.target === val.id) {
                top = edge.source;
              }
            } else {
              if (edge.source === val.id) {
                bottom = edge.target;
              }
              if (edge.target === val.id) {
                top = edge.source;
              }
            }
          });
          val.BackendData.top = top;
          val.BackendData.bottom =
            val.data.label === "Trigger" ? bottomArray : bottom;
        }
      });
    }

    const filteredData = selectedSchedule.Day.map((val) => {
      if (!val.Active) {
        val.StartHour = 0;
        val.EndHour = 0;
      }
      return val;
    });

    let nodeData = {
      dateFormat: selectedSchedule.TimeZone,
      day: filteredData,

      fromEmail: accountList,
      // name list selecedfrom the contact
      //nameListObj._id
      //toData:nameList._id ,
      sequence: locData.state.isEnableSequence,
      sentStrategy: abTestingStratergy,
      structure: locData.state.isEnableSequence ? sequenceData : nodes,
      allContact: emailType === "all",
      timeGap: timeLimit * 60,
      missingVariable: true,
      nameListId: nameListId,
      name: locData.state.campaignName,
      stopOnReply: true,
      ccEmail:
        ccEmails.length !== 0
          ? ccEmails.split(",").map((val) => {
              if (isValidEmail(val)) {
                return val;
              }
            })
          : [],
      bccEmail:
        bccEmails !== undefined && bccEmails.length !== 0
          ? bccEmails.split(",").map((val) => {
              if (isValidEmail(val)) {
                return val;
              }
            })
          : [],
      abTesting: abTestingStatus,
      abTestingOptimize: abTestingWin,
      campaignCopy: saveLocalStorageData(),
      sendOption: {
        Unverified: emailRiskType[0].value,
        Unverifiable: emailRiskType[1].value,
      },
      duration: {
        Status: campDuration,
        CountryDateTime: countryTimeSchedule2,
        StartDate: campStartDate,
        EndDate: campEndDate,
      },
    };
    console.log("nodedata", nodeData);
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/create-automation-campaign/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(nodeData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setShowToaster(true);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (!campDuration) {
            runPendingCampaign(res.data.campaignId);
          } else {
            history.push("/DashBoard/Campaign");
          }
          localStorage.removeItem("draftedcampaigndata");
        } else {
          setPublishLoader(false);
          setShowToaster(true);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        // setPublishLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  const captureComponentAsImage = () => {
    if (reactFlowWrapper.current) {
      toPng(document.querySelector(".react-flow__viewport"))
        .then((dataUrl) => {
          setImageSrc(dataUrl);
          setSequenceLoader(false);
          setType("sending");
        })
        .catch((error) => {
          console.error("Error capturing component as image:", error);
        });
    }
  };

  function convertTo24HourFormat(time) {
    const [timePart, ampm] = time.split(" ");
    const [hours, minutes] = timePart.split(":");
    let hour = parseInt(hours, 10);

    if (ampm === "PM" && hour < 12) {
      hour += 12;
    } else if (ampm === "AM" && hour === 12) {
      hour = 0;
    }

    return hour.toString().padStart(2, "0");
  }
  function createSchedule() {
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/automation/create-schedule/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setNewSchedule(false);
          setSelectedSchedule("");
          getShceduleData();
        } else {
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function getShceduleData() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-schedule/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setScheduleData(res.data.details);
        } else {
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function createNewNameList() {
    let nameListDatas = {
      name: listName,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/contact/create-name-list/${
          userDetails && userDetails.details._id
        }`,
        nameListDatas,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpen(false);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllSendEmails();
  }, []);
  function getAllSendEmails() {
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/get-all-user-from-emails-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setSenderMails(response.data.details.AddedEmails);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function onConnectStart(event, node) {}
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEdge, setSelectedEdge] = useState(false);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const [updateLoader, setUpdateLoader] = useState(false);
  const Modals = ({ x, y, isOpen, onClose }) => {
    const modalStyle = {
      display: isOpen ? "block" : "none",
      position: "fixed",
      top: y - 25, // Adjust the top position to center vertically
      left: x - 76, // Adjust the left position to center horizontally

      background: "white",
      border: "1px solid #ccc",
      padding: "6px",
      borderRadius: "10px",
    };

    return (
      <div style={modalStyle}>
        <div className="edgemodalbox">
          <div className="delteselectedtext">Delete Selected Link</div>
          <div
            className="deleteEdgeButonBox"
            onClick={() => {
              removeSelectedEdge();
            }}
          >
            Delete
          </div>
        </div>
      </div>
    );
  };
  function removeSelectedEdge() {
    const arrObj2 = edges.filter((obj) => obj.id !== selectedEdge.id);
    setEdges([]);
    setTimeout(() => {
      setEdges(arrObj2);
    }, 50);

    handleCloseModal();
  }
  function runPendingCampaign(campId) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/automation/check-run-automation-campaign/${
        userDetails && userDetails.details._id
      }/${campId}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          history.push("/DashBoard/Campaign");
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function deleteScheduleById() {
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/automation/delete-schedule/${
          userDetails && userDetails.details._id
        }/${selectedSchedule._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setSelectedSchedule("");
          setOpen6(false);
        } else {
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function convertTo12HourFormat(hour) {
    // Check if the input is a valid number between 0 and 23
    if (typeof hour !== "number" || hour < 0 || hour > 23) {
      return "Invalid input";
    }

    // Convert 24-hour format to 12-hour format
    if (hour === 0) {
      return "12:00 AM";
    } else if (hour < 12) {
      return hour + ":00 AM";
    } else if (hour === 12) {
      return "12:00 PM";
    } else {
      return hour - 12 + ":00 PM";
    }
  }
  function updateSchedule() {
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/update-schedule-days/${
          userDetails && userDetails.details._id
        }/${selectedSchedule._id}`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setNewSchedule(false);
          setSelectedSchedule("");
        } else {
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function nextStepsOfCampaign() {
    if (type === "sequence") {
      if (locData.state.isEnableSequence) {
        let vig = 0;
        let counter = 0;
        let init = ``;
        sequenceData.map((val) => {
          if (val.data.label === "email") {
            counter++;
              const htmlString = val.BackendData.data.body;
              const parser = new DOMParser();
              const doc = parser.parseFromString(htmlString, "text/html");
              const spans = doc.querySelectorAll("span.clickable-span");
              spans.forEach((span) => span.removeAttribute("style"));
              const modifiedHtml = doc.body.innerHTML;
              /////
              const htmlStringB = val.BackendData.data.bodyB;
              const docB = parser.parseFromString(htmlStringB, "text/html");
              const spansB = docB.querySelectorAll("span.clickable-span");
              spansB.forEach((span) => span.removeAttribute("style"));
              const modifiedHtmlB = docB.body.innerHTML;

              const htmlStringSubject = val.BackendData.data.subject;
              const docSubject = parser.parseFromString(htmlStringSubject, "text/html");
              const spansSubject = docSubject.querySelectorAll("span.clickable-span");
              spansSubject.forEach((span) => span.removeAttribute("style"));
              const modifiedHtmlSubject = docSubject.body.innerHTML;
          
              const htmlStringBSubject = val.BackendData.data.subjectB;
              const docBSubject = parser.parseFromString(htmlStringBSubject, "text/html");
              const spansBSubject = docBSubject.querySelectorAll("span.clickable-span");
              spansBSubject.forEach((span) => span.removeAttribute("style"));
              const modifiedHtmlBSubject = docBSubject.body.innerHTML;
              val.BackendData.data.body=[
                ReactDOMServer.renderToString(modifiedHtml).slice(0, 0),
                modifiedHtml.slice(0),
                ``,
              ].join("")
              val.BackendData.data.bodyB=[
                ReactDOMServer.renderToString(modifiedHtmlB).slice(0, 0),
                modifiedHtmlB.slice(0),
                ``,
              ].join("")
              val.BackendData.data.subject=[
                ReactDOMServer.renderToString(modifiedHtmlSubject).slice(0, 0),
                modifiedHtmlSubject.slice(0),
                ``,
              ].join("")
              val.BackendData.data.subjectB=[
                ReactDOMServer.renderToString(modifiedHtmlBSubject).slice(0, 0),
                modifiedHtmlBSubject.slice(0),
                ``,
              ].join("")
           
          }
          if (val.data.label === "email") {
            if (val.BackendData.data.ABTesting) {
              if (val.BackendData.data.subjectA === "") {
                toast.error(`Step ${counter} Email Subject A is empty`);
                vig = 1;
              } else if (val.BackendData.data.subjectB === "") {
                toast.error(`Step ${counter} Email Subject B is empty`);
                vig = 1;
              }
              else
              if (
                val.BackendData.data.bodyA.replace(/\s/g, "") ===
                init.replace(/\s/g, "")
              ) {
                toast.error(`Step ${counter} Email body A is empty`);
                vig = 1;
              } else if (
                val.BackendData.data.bodyB.replace(/\s/g, "") ===
                init.replace(/\s/g, "")
              ) {
                toast.error(`Step ${counter} Email body B is empty`);
                vig = 1;
              }
            } else {
              if (val.BackendData.data.subject === "") {
                toast.error(`Step ${counter} Email Subject is empty`);
                vig = 1;
              } else if (
                val.BackendData.data.body.replace(/\s/g, "") ===
                init.replace(/\s/g, "")
              ) {
                toast.error(`Step ${counter} Email body is empty`);
                vig = 1;
              }
            }
          }
        });
        console.log("vikki ivar",sequenceData)
        if (vig === 0) {
          setType("sending");
        } else {
          return;
        }
      } else {
        setSequenceLoader(true);
        let vikki = nodes;
        if (vikki.length === 1) {
          setSequenceLoader(false);
        } else {
          if (
            vikki.slice(1).every((obj) => obj.hasOwnProperty("BackendData"))
          ) {
            let objectsWithoutBackendData = [];
            let err = [];
            let successCount = 0;
            vikki.slice(1).map((val, indexxxx) => {
              if (val.data.label !== "Goal") {
                console.log("nodes", vikki);
                console.log("edges", edges);
                if (val.data.label === "Trigger") {
                  if (
                    edges.some((obj) => obj.id.includes(`edge-${val.id}b`)) &&
                    edges.some((obj) => obj.id.includes(`edge-${val.id}a`))
                  ) {
                    successCount = successCount + 1;
                  } else {
                    setSequenceLoader(false);
                    setOpen7(true);
                    err.push("Add a node to the highlighted trigger");
                    objectsWithoutBackendData.push(val);
                  }
                } else {
                  if (
                    edges.some((obj) => obj.source === val.id) &&
                    edges.some((obj) => obj.target === val.id)
                  ) {
                    successCount = successCount + 1;
                    // setOpen7(false);
                    // captureComponentAsImage();
                  } else {
                    setSequenceLoader(false);
                    setOpen7(true);
                    if (val.data.label === "email") {
                      err.push("Add a node to the highlighted email");
                    } else if (val.data.label === "Trigger") {
                      err.push("Add a node to the highlighted trigger");
                    } else if (val.data.label === "Delay") {
                      err.push("Add a node to the highlighted delay");
                    } else if (val.data.label === "Goal") {
                      err.push("Add a node to the highlighted goal");
                    }
                    objectsWithoutBackendData.push(val);
                  }
                }
              } else {
                successCount = successCount + 1;
              }
            });
            if (successCount === nodes.length - 1) {
              setOpen7(false);
              captureComponentAsImage();
            }
            console.log("successcount", successCount, nodes.length);
            setErrorMessage(err);
            setErroredNode(objectsWithoutBackendData);
          } else {
            let err = [];
            let objectsWithoutBackendData = vikki
              .slice(1)
              .filter((obj) => !obj.hasOwnProperty("BackendData"));
            if (objectsWithoutBackendData.length !== 0) {
              objectsWithoutBackendData.map((val) => {
                if (val.data.label === "email") {
                  err.push("Add a subject and body to the highlighted email");
                } else if (val.data.label === "Trigger") {
                  err.push(
                    "Add a trigger and waiting time to the highlighted trigger"
                  );
                } else if (val.data.label === "Delay") {
                  err.push("Add a waiting time to the highlighted delay");
                } else if (val.data.label === "Goal") {
                  err.push("Add a goal name to the highlighted goal");
                }
              });
            }
            vikki.slice(1).map((val) => {
              if (val.data.label !== "Goal") {
                if (
                  edges.some((obj) => obj.source === val.id) &&
                  edges.some((obj) => obj.target === val.id)
                ) {
                } else {
                  objectsWithoutBackendData.push(val);
                  if (val.data.label === "email") {
                    err.push("Add a node to the highlighted email");
                  } else if (val.data.label === "Trigger") {
                    err.push("Add a node to the highlighted trigger");
                  } else if (val.data.label === "Delay") {
                    err.push("Add a node to the highlighted delay");
                  } else if (val.data.label === "Goal") {
                    err.push("Add a node to the highlighted goal");
                  }
                  objectsWithoutBackendData.push(val);
                }
              }
            });

            setOpen7(true);
            setErroredNode(objectsWithoutBackendData);
            setErrorMessage(err);
            setSequenceLoader(false);
          }
        }
      }
    } else if (type === "prospect") {
      setType("sequence");
    } else if (type === "sending") {
      if (selectedSchedule === "" || accountList.length === 0) {
        if (selectedSchedule === "" && accountList.length === 0) {
          toast.error("Please select email account and schedule!!");
        } else {
          if (selectedSchedule === "") {
            toast.error("Please select required schedule!!");
          } else if (accountList.length === 0) {
            toast.error("Please select atleast one email account!!");
          }
        }
      } else {
        setType("review");
      }
    } else if (type === "review") {
      setReturnStatus(true);
      setPublishLoader(true);
      if (locData.state.from === "edit") {
        setOpenMuiModal(true)
      
      } else {
        sendDataBackend();
      }
    }
  }
  function updateDataBackend() {
    setUpdateLoader(true)
    if(!locData.state.isEnableSequence){
      nodes.map((val) => {
        let top, bottom;
        let bottomArray = [];
        if (val.BackendData !== undefined) {
          edges.map((edge) => {
            if (val.data.label === "Trigger") {
              if (edge.source === val.id) {
                bottomArray.push({
                  Edge: edge.target,
                  Target: edge.sourceHandle === "a" ? "no" : "yes",
                });
              }
              if (edge.target === val.id) {
                top = edge.source;
              }
            } else {
              if (edge.source === val.id) {
                bottom = edge.target;
              }
              if (edge.target === val.id) {
                top = edge.source;
              }
            }
          });
          val.BackendData.top = top;
          val.BackendData.bottom =
            val.data.label === "Trigger" ? bottomArray : bottom;
        }
      });
    }
   

    const filteredData = selectedSchedule.Day.map((val) => {
      if (!val.Active) {
        val.StartHour = 0;
        val.EndHour = 0;
      }
      return val;
    });
    let nodeData = {
      dateFormat: selectedSchedule.TimeZone,
      day: filteredData,

      fromEmail: accountList,
      // name list selecedfrom the contact
      //nameListObj._id
      //toData:nameList._id ,
      sequence: locData.state.isEnableSequence,
      structure: locData.state.isEnableSequence ? sequenceData : nodes,
      allContact: emailType === "all",
      timeGap: timeLimit * 60,
      missingVariable: checkType === "check",
      nameListId: nameListId,
      name: locData.state.campaignName,
      stopOnReply: true,
      campaignCopy: saveLocalStorageData(),
      sendOption: {
        Unverified: emailRiskType[0].value,
        Unverifiable: emailRiskType[1].value,
      },
      duration: {
        Status: campDuration,
        CountryDateTime: countryTimeSchedule2,
        StartDate: campStartDate,
        EndDate: campEndDate,
      },
    };
    console.log('updatenode',nodeData)
    axios
      .put(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/update-automation-campaign/${
          userDetails && userDetails.details._id
        }/${locData.state.campaignId}`,
        { data: JSON.stringify(nodeData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          if (!campDuration) {
            runPendingCampaign(res.data.campaignId);
          } else {
            history.push("/DashBoard/Campaign");
          }
          runPendingCampaign(res.data.campaignId);
          localStorage.removeItem("draftedcampaigndata");
        } else {
          setPublishLoader(false);
          setUpdateLoader(false)
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        
      })
      .catch((err) => console.log("Error"));
  }

  const [openEmailEmailInstructionModal, setOpenEmailEmailInstructionModal] =
    useState(false);
  const [openEmailAccountDrawer, setOpenEmailAccountDrawer] = useState(false);

  const catchPropsData = (data) => {
    setShowToaster(true);
    if (data.status) {
      getAllSendEmails();
      toast.success(data.message, {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setOpenEmailAccountDrawer(false);
    } else {
      getAllSendEmails();
      toast.error(data.message, {
        autoClose: true,
        position: "top-right",
        duration: 3000,
      });
      setOpenEmailAccountDrawer(true);
    }
  };
  const [openMuiModal,setOpenMuiModal] = useState(false)

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openMuiModal}
        onClose={() => {
          setPublishLoader(false);
          setOpenMuiModal(false)}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openMuiModal}>
          <Box sx={style}>
            <Typography
              sx={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "700",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
            Updating this campaign will overwrite the previous data, resulting in the creation of a new, updated campaign
            </Typography>
          
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <button
                onClick={() => {
                  setOpenMuiModal(false);
                  setPublishLoader(false);
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              <button
              onClick={()=>{
                
                updateDataBackend();
              }}
                style={{
                  textTransform: "none",
                  // background:"#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 26px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
                className="bg-primary"
              >
                {updateLoader ? (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "white",
                    }}
                  />
                ) : (
                  <>Continue</>
                )}
                
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const [openScheduleDrawer, setOpenScheduleDrawer] = useState(false);
  const [returnStatus, setReturnStatus] = useState(false);
  const [openBackModal, setOpenBackModal] = useState(false);
  let stepCounter = 0;
  function addNodeSequence() {
    sequenceData[
      sequenceData.length - 1
    ].BackendData.bottom = `dndnode_${sequenceData.length}`;
    let nodemailData = {
      id: `dndnode_${sequenceData.length}`,
      data: { label: "email" },
      BackendData: {
        data: {
          ABTesting: false,
          subject: "",
          body: ``,
          subjectA: "",
          bodyA: ``,
          subjectB: "",
          bodyB: ``,
        },
        top: sequenceData[sequenceData.length - 1].id,
        bottom: `dndnode_${sequenceData.length + 1}`,
      },
    };
    let nodeDelayData = {
      id: `dndnode_${sequenceData.length + 1}`,
      data: { label: "Delay" },
      BackendData: {
        data: { count: 1, type: "Days" },
        top: `dndnode_${sequenceData.length}`,
        bottom: "",
      },
    };
    sequenceData.push(nodemailData);
    sequenceData.push(nodeDelayData);
    console.log("seqencefinal", sequenceData);
    setSequenceData([...sequenceData]);
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }
  function removeSomeValue(index) {
    if (index === sequenceData.length - 2) {
      sequenceData[index - 1].BackendData.bottom = "";
    } else {
      sequenceData[index - 1].BackendData.bottom = sequenceData[index + 2].id;
      sequenceData[index + 2].BackendData.top = sequenceData[index - 1].id;
    }

    setSelectedSequence(index - 2);
    sequenceData.splice(index, 2);
    // console.log("final sequence", sequenceData);
    setSequenceData([...sequenceData]);
    setOpenDeleteCard(false);
  }
  const [openDeleteCard, setOpenDeleteCard] = useState(false);
  const [deletedIndexCard, setDeletedIndexCard] = useState("");

  const openDeleteModal = () => {
    return (
      <Modal
        open={openDeleteCard}
        onClose={() => {
          setOpenDeleteCard(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext" style={{ fontSize: "16px" }}>
            Confirm Delete
          </div>
          <div className="modalsubtext">
            Are you sure you want to delete this card?
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpenDeleteCard(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                removeSomeValue(deletedIndexCard);
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  const scrollToBottom = () => {
    console.log("bottomref", bottomRef);
    bottomRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div
      style={{
        height: "100%",
        position: "relative",
      }}
    >
      {" "}
      <Modal
        open={openBackModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltextdelete" style={{ width: "100%" }}>
            Save Changes{" "}
          </div>
          <div className="modalsubtextfordelete">
            You have unsaved changes for this campaign. To save your work,
            select Save.
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
              marginTop: "16px",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setReturnStatus(true);
                history.push("/DashBoard/Campaign");
              }}
            >
              Discard
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                setReturnStatus(true);
                setLocalStorageData();
                history.push("/DashBoard/Campaign");
              }}
            >
              Save
            </div>
          </div>
        </div>
      </Modal>
      {locData.state.from !== "edit" && (
        <>
          {returnStatus ? (
            <Prompt
              message={() => {
                setOpenBackModal(false);

                return true;
              }}
            />
          ) : (
            <Prompt
              message={() => {
                setOpenBackModal(true);
                setReturnStatus(true);
                return false;
              }}
            />
          )}
        </>
      )}
      <Helmet>
        <title>New Campaign</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      {openScheduleDrawer && (
        <CreateScheduleDrawer
          openCreateScheduleDrawer={openScheduleDrawer}
          setterFun={setOpenScheduleDrawer}
          selectedScheduleData={selectedSchedule}
          selectedScheduleSetterFun={setSelectedSchedule}
        />
      )}
      <div
        style={{
          padding: "16px",
          // background: "yellow",
          height: "calc(100% - 50px)",
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            backgroundColor: "#FFF",
            border: "1px solid #DDD",
            borderRadius: "5px",
          }}
        >
          {/* left side container view */}
          <div
            style={{
              borderRight: "1px solid #DDD",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "120px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "transparent",
                height: "100%",
                paddingTop: "12px",
              }}
            >
              <div className="sequesce">
                <div
                  className={`${
                    type === "prospect"
                      ? "sequencenumber"
                      : "sequencenumberfullpink"
                  }`}
                >
                  1
                </div>
                <div className="sequncetext">List</div>
                {type === "prospect" ? (
                  <div className="barpink"></div>
                ) : (
                  <div className="bardarkpink"></div>
                )}
              </div>
              <div className="processofcampaign">
                <div
                  className={`${
                    type === "prospect"
                      ? "roundedgraycircle"
                      : type === "sequence"
                      ? "sequencenumber"
                      : "sequencenumberfullpink"
                  }`}
                >
                  2
                </div>
                <div className="sequncetext">Sequence</div>
                {type === "prospect" ? (
                  <div className="bargray"></div>
                ) : type === "sequence" ? (
                  <div className="barpink"></div>
                ) : (
                  <div className="bardarkpink"></div>
                )}
              </div>
              <div className="processofcampaign">
                <div
                  className={`${
                    type === "prospect" || type === "sequence"
                      ? "roundedgraycircle"
                      : type === "sending"
                      ? "sequencenumber"
                      : "sequencenumberfullpink"
                  }`}
                >
                  3
                </div>
                <div className="sequncetext">Sending</div>
                {type === "prospect" || type === "sequence" ? (
                  <div className="bargray"></div>
                ) : type === "sending" ? (
                  <div className="barpink"></div>
                ) : (
                  <div className="bardarkpink"></div>
                )}
              </div>
              <div className="processofcampaign">
                <div className="roundedgraycircle">4</div>
                <div className="sequncetext">Review</div>
              </div>
            </div>
          </div>

          {/* right side container view */}
          <div
            style={{
              flexGrow: 1,
              overflow: type !== "review" ? "auto" : null,
            }}
          >
            {type === "sequence" && (
              <>
                {!locData.state.isEnableSequence ? (
                  <div
                    className="dndflow"
                    style={{ height: "100%" }}
                    ref={reactFlowWrapper}
                  >
                    <ReactFlowProvider>
                      <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        onEdgeClick={onEdgeClick}
                        onNodesChange={onNodesChange}
                        // onEdgesChange={onEdgesChange}
                        onConnect={onConnect}
                        onInit={setReactFlowInstance}
                        onDrop={onDrop}
                        onDragOver={onDragOver}
                        nodeTypes={nodeTypes}
                        // onNodeDrag={onDrag}
                        edgeTypes={edgeTypes}
                        onNodeDragStop={onNodeDrop}
                        maxZoom={0.9}
                        // onNodeClick={handleNodeClick}
                        onNodeMouseEnter={handleNodeMouseEnter}
                        onNodeMouseLeave={handleNodeMouseLeave}
                        zoomOnScroll={false}
                        panOnScroll={true}
                      >
                        <Background color="white" gap={16} />
                        <Controls />
                      </ReactFlow>
                    </ReactFlowProvider>
                  </div>
                ) : (
                  <div style={{ padding: "10px", height: "100%" }}>
                    <div
                      className="grid grid-cols-12 gap-4"
                      style={{ height: "100%" }}
                    >
                      <div
                        style={{ height: "100%", overflow: "auto" }}
                        className="col-span-3"
                      >
                        <ul
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "6px",
                          }}
                        >
                          {sequenceData.map((data, i) => {
                            if (i === 0) {
                              return null;
                            }
                            if (data.data.label === "email") {
                              stepCounter++;
                            }
                            return (
                              <div
                                style={{
                                  borderLeft:
                                    (selectedSequence === i ||
                                      selectedSequence === i - 1) &&
                                    "1.4px solid #ff3301",
                                  borderRight:
                                    (selectedSequence === i ||
                                      selectedSequence === i - 1) &&
                                    "1.4px solid #ff3301",
                                  borderTop:
                                    (selectedSequence === i ||
                                      selectedSequence === i - 1) &&
                                    data.data.label === "email" &&
                                    "1.4px solid #ff3301",
                                  borderBottom:
                                    (selectedSequence === i ||
                                      selectedSequence === i - 1) &&
                                    data.data.label === "Delay" &&
                                    "1.4px solid #ff3301",
                                  borderTopLeftRadius:
                                    data.data.label === "email" && "8px",
                                  borderTopRightRadius:
                                    data.data.label === "email" && "8px",
                                  borderBottomLeftRadius:
                                    data.data.label === "Delay" && "8px",
                                  borderBottomRightRadius:
                                    data.data.label === "Delay" && "8px",
                                  marginBottom:
                                    data.data.label === "Delay" && "12px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#f9f9f9",
                                    borderTopLeftRadius: "8px",
                                    borderTopRightRadius: "8px",
                                  }}
                                >
                                  {data.data.label === "email" && (
                                    <>
                                      <div
                                        style={{
                                          // padding: "8px 6px",
                                          display: "flex",
                                          // justifyContent: "space-between",
                                          alignItems: "center",
                                          // padding: "10px 6px",
                                          borderBottom: "1px solid #DDD",
                                        }}
                                      >
                                        <p
                                          onClick={() => {
                                            console.log("vikki",i)
                                            setSelectedSequence(i);
                                          }}
                                          style={{
                                            color: "#000",
                                            fontFamily: "Source Sans 3",
                                            fontSize: "14px",
                                            fontWeight: 700,
                                            marginBottom: 0,
                                            fontStyle: "normal",
                                            width: "85%",
                                            padding: "8px 6px",
                                          }}
                                        >
                                          Step {stepCounter}
                                        </p>

                                        {sequenceData.length > 3 && (
                                          <button
                                            onClick={() => {
                                              setOpenDeleteCard(true);
                                              setDeletedIndexCard(i);
                                              // removeSomeValue(i);
                                            }}
                                          >
                                            <DeleteOutlineIcon
                                              sx={{
                                                color: "#868686",
                                              }}
                                            />
                                          </button>
                                        )}
                                      </div>
                                      <div
                                        onClick={() => {
                                          setSelectedSequence(i);
                                        }}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "14px",
                                          padding: "12px 10px",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#393939",
                                            fontFamily: "Source Sans 3",
                                            width: "100%",
                                            height: "max-content",
                                            overflowX: "auto",
                                            fontSize: "14px",
                                            fontWeight: 700,
                                            marginBottom: 0,
                                            fontStyle: "normal",
                                            backgroundColor: "#FFF",
                                            padding: data.BackendData.data
                                              .subject
                                              ? "6px"
                                              : "16px",
                                            borderRadius: 5,
                                            border: "1px solid #DDD",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              data.BackendData.data.subject,
                                          }}
                                        />
                                        <FormControlLabel
                                          onClick={() => {
                                            sequenceData[
                                              i
                                            ].BackendData.data.ABTesting =
                                              !sequenceData[i].BackendData.data
                                                .ABTesting;
                                            setSequenceData([...sequenceData]);
                                          }}
                                          sx={{
                                            marginRight: "0px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                          control={
                                            <Switch
                                              checked={
                                                data.BackendData.data.ABTesting
                                              }
                                              style={{
                                                color: "#1c485f",
                                                marginRight: "0px",
                                              }}
                                            />
                                          }
                                          label="A/B Testing"
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                                {data.data.label === "Delay" && (
                                  <div
                                    onClick={() => {
                                      setSelectedSequence(i - 1);
                                    }}
                                    style={{
                                      borderTop:
                                        i !== sequenceData.length - 1 &&
                                        "1px solid #DDD",
                                      backgroundColor: "#f9f9f9",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 5,
                                      padding: "10px 6px",
                                      borderBottomLeftRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                    }}
                                  >
                                    {i !== sequenceData.length - 1 && (
                                      <>
                                        <p>Delay</p>
                                        <input
                                          type="text"
                                          style={{
                                            outline: "none",
                                            width: "46px",
                                            padding: "6px",
                                            backgroundColor: "#FFF",
                                            border: "1px solid #DDD",
                                            borderRadius: 5,
                                          }}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 2) {
                                              data.BackendData.data.count =
                                                e.target.value;
                                              setSequenceData([
                                                ...sequenceData,
                                              ]);
                                            }
                                          }}
                                          value={data.BackendData.data.count}
                                        />
                                        <p>Days</p>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                          <div ref={bottomRef} />
                          <button
                            style={{
                              color: "#868686",
                              borderRadius: 5,
                              padding: "8px 12px",
                              outline: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow:
                                "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                              gap: 3,
                            }}
                            onClick={() => {
                              addNodeSequence();
                            }}
                          >
                            <PlusCircleSvg />
                            Add Step
                          </button>
                        </ul>
                      </div>
                      <div
                        style={{
                          backgroundColor: "#FFF",
                        }}
                        className="col-span-9"
                      >
                        <SequenceEditor
                          subject={subject}
                          setSubject={setSubject}
                          subjectB={subjectB}
                          setSubjectB={setSubjectB}
                          setEmailBody={setEmailBody}
                          emailBody={emailBody}
                          setEmailBodyB={setEmailBodyB}
                          emailBodyB={emailBodyB}
                          createEmailForNode={createEmailForNode}
                          setOpen3={setOpen3}
                          setLocalStorageData={setLocalStorageData}
                          setABTestingStatus={setABTestingStatus}
                          abTestingStatus={abTestingStatus}
                          variableArray={variableArray}
                          setSequenceData={setSequenceData}
                          sequenceData={sequenceData}
                          selectedSequence={selectedSequence}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {type === "prospect" && (
              <div
                className="prospectwholestyle"
                style={{
                  height: "100%",
                }}
              >
                <div className="prospectheadingstyle">List</div>
                {listLoader ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <CircularProgress
                      size={30}
                      style={{
                        color: "#1C485F",
                      }}
                    />
                  </div>
                ) : (
                  <div className="prospectbdy">
                    {nameListArr.length !== 0 ? (
                      <div className="prospdesc">
                        <p>
                          Email campaign will be started for all List from the
                          list. If a new prospect is added to the list, the
                          email campaign for the prospect will begin at the
                          moment of its adding to the list.
                        </p>
                        <div className="listnametext">
                          {nameListArr.length !== 0 && (
                            <p
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "13px",
                                fontWeight: 400,
                                fontStyle: "normal",
                              }}
                            >
                              List name
                            </p>
                          )}

                          <button
                            style={{ outline: "none" }}
                            onClick={() => {
                              setOpenDrawerForCreateList(true);
                              // setOpen(true);
                              // history.push("/Lists");
                              // if (locData.state.from !== "edit") {
                              //   setLocalStorageData();
                              // }
                            }}
                            className="createnewlistbox"
                          >
                            Create new list
                          </button>
                        </div>
                        {nameListArr.length !== 0 && (
                          <div style={{ width: "100%" }}>
                            <FormControl size="medium" sx={{ width: "100%" }}>
                              <Select
                                displayEmpty
                                variant="standard"
                                value={nameList}
                                disableUnderline
                                onChange={handleChange6}
                                sx={{
                                  outline: "none",
                                  backgroundColor: "#FAFAFA",
                                  padding: "10px",
                                  borderRadius: "4px",
                                  border: "1px solid #1C485F",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "15px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                }}
                                renderValue={(selected) => {
                                  if (selected.length === 0) {
                                    return (
                                      <em
                                        style={{
                                          fontStyle: "normal",
                                          fontSize: "14px",
                                          color: "#888888",
                                        }}
                                      >
                                        Select a list name
                                      </em>
                                    );
                                  }
                                  return selected;
                                }}
                                inputProps={{ "aria-label": "Without label" }}
                              >
                                {nameListArr.map((list, index) => (
                                  <MenuItem
                                    disableRipple
                                    disableTouchRipple
                                    key={list._id}
                                    value={list}
                                    sx={{
                                      borderBottom:
                                        nameListArr.length !== index + 1 &&
                                        "1px solid #DDD",
                                      fontFamily: "Source Sans 3",
                                      fontSize: "14px",
                                      fontWeight: 400,
                                      fontStyle: "normal",
                                    }}
                                  >
                                    {list.Name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        )}
                      </div>
                    ) : (
                      nameListArr.length === 0 && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            gap: "14px",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "20px 0px",
                          }}
                        >
                          <img
                            src={notEmptyImage}
                            alt="none"
                            style={{ height: "200px", width: "auto" }}
                          />
                          <p
                            style={{
                              color: "#868686",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontWeight: 400,
                              fontStyle: "normal",
                            }}
                          >
                            Oops, no list found. Kindly create a list first.
                          </p>
                          <button
                            style={{ outline: "none" }}
                            onClick={() => {
                              // setOpen(true);
                              setOpenDrawerForCreateList(true);
                              if (locData.state.from !== "edit") {
                                setLocalStorageData();
                              }
                            }}
                            className="createnewlistbox"
                          >
                            Create new list
                          </button>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            )}
            {type === "sending" && (
              <div
                className="prospectwholestyle"
                style={{
                  paddingBottom: "10px",
                }}
              >
                <div className="prospectheadingstyle">Sending options</div>
                <div
                  style={{
                    padding: "8px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <div className="sendingOptionstyle">
                    {senderMails.length !== 0 && (
                      <div className="accountusestyle">
                        <div
                          style={{
                            color: "#393939",
                            fontFamily: "Source Sans 3",
                            fontWeight: 600,
                            fontStyle: "normal",
                            fontSize: "14px",
                          }}
                        >
                          Accounts to use
                        </div>
                        <div className="accoutnsuesub">
                          Select one or more accounts to send emails from
                        </div>
                      </div>
                    )}

                    {senderMails.length !== 0 && (
                      <FormControl size="medium" sx={{ width: "100%" }}>
                        <Select
                          displayEmpty
                          disableUnderline
                          multiple
                          maxRows={4}
                          variant="standard"
                          value={accountList}
                          onChange={handleChange8}
                          IconComponent={ArrowDropDownIcon}
                          inputProps={{
                            sx: {
                              display: "flex",
                              flexDirection: "row",
                              gap: "5px",
                            },
                          }}
                          sx={{
                            outline: "none",
                            backgroundColor: "#FAFAFA",
                            padding: "10px",
                            borderRadius: "4px",
                            fontFamily: "Source Sans 3",
                            fontSize: "15px",
                            fontWeight: 400,
                            fontStyle: "normal",
                            border: "1px solid #1C485F",
                          }}
                        >
                          {senderMails.length !== 0 &&
                            senderMails.map((val) => {
                              return (
                                <MenuItem
                                  sx={{
                                    color: "var(--color-dark-600, #727272)",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                  }}
                                  value={val._id}
                                >
                                  <div style={{ display: "flex", gap: "7px" }}>
                                    <Checkbox
                                      style={{ padding: 0 }}
                                      sx={{
                                        color: "#1c485f",
                                        "&.Mui-checked": {
                                          color: "#1c485f",
                                        },
                                        "& .MuiSvgIcon-root": { fontSize: 20 },
                                      }}
                                      checked={
                                        accountList.indexOf(val._id) > -1
                                      }
                                    />
                                    {val.FromEmail}
                                  </div>
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    )}
                    <div className="dailylimitbox">
                      <div className="dailylimitinsidebox">
                        <div
                          style={{
                            color: "#393939",
                            fontFamily: "Source Sans 3",
                            fontWeight: 600,
                            fontStyle: "normal",
                            fontSize: "14px",
                          }}
                        >
                          Select A/B Testing Stratergy
                        </div>
                        <div className="triggerrounded">
                          <div className="radioboxstyle">
                            <FormControlLabel
                              value="Opened"
                              control={<Radio style={{ color: "#1C485F" }} />}
                              label="Opened email"
                              onClick={(e) => {
                                setAbTestingStratergy(e.target.value);
                              }}
                              checked={abTestingStratergy === "Opened"}
                            />
                          </div>
                          <div className="radioboxstyle">
                            <FormControlLabel
                              value="Clicked"
                              control={<Radio style={{ color: "#1C485F" }} />}
                              label="Clicked on a link"
                              onClick={(e) => {
                                setAbTestingStratergy(e.target.value);
                              }}
                              checked={abTestingStratergy === "Clicked"}
                            />
                            <FormControlLabel
                              value="Reply"
                              control={<Radio style={{ color: "#1C485F" }} />}
                              label="Reply Rate"
                              onClick={(e) => {
                                setAbTestingStratergy(e.target.value);
                              }}
                              checked={abTestingStratergy === "Reply"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        // setOpen3(true);
                        // setSelected("newemail");
                        if (locData.state.from !== "edit") {
                          setLocalStorageData();
                        }
                        // history.push("/Email/accounts");
                        setOpenEmailEmailInstructionModal(true);
                      }}
                      className="addnewemailaccount"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M6.66797 10.9607H13.3346"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 14.294V7.62738"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.5013 19.294H12.5013C16.668 19.294 18.3346 17.6274 18.3346 13.4607V8.46071C18.3346 4.29405 16.668 2.62738 12.5013 2.62738H7.5013C3.33464 2.62738 1.66797 4.29405 1.66797 8.46071V13.4607C1.66797 17.6274 3.33464 19.294 7.5013 19.294Z"
                          stroke="#1C485F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Add New Email Account
                    </div>
                  </div>

                  <div className="dailylimitbox">
                    <div className="dailylimitinsidebox">
                      <div
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontWeight: 600,
                          fontStyle: "normal",
                          fontSize: "14px",
                        }}
                      >
                        Time gap between emails
                      </div>
                    </div>
                    <div className="timeapboxalign">
                      <div className="timegapseperatebox">
                        Minimum time (Minutes 2 to 30)
                        <TextField
                          autoComplete="off"
                          value={timeLimit}
                          onChange={handleChangesss}
                          inputProps={{
                            pattern: "^(2[0-9]|[2-9]|1[0-9]|30)$",
                          }}
                          helperText={!isValid ? "Invalid input" : ""}
                          error={!isValid}
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              display: "flex",
                              padding: "10px 16px",
                              alignItems: "center",
                              gap: "10px",
                              borderRadius: "4px",
                              border: "1px solid #1C485F",
                              background: "var(--background-color, #FAFAFA)",
                              width: "120px",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignSelf: "stretch",
                              "& input": {
                                color: "var(--color-dark-500, #868686)",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px",
                                marginLeft: "70px",
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {abTestingStatus && (
                    <div className="dailylimitbox">
                      <div className="dailylimitinsidebox">
                        <div
                          style={{
                            color: "#393939",
                            fontFamily: "Source Sans 3",
                            fontWeight: 600,
                            fontStyle: "normal",
                            fontSize: "14px",
                          }}
                        >
                          Auto Optimize A/B testing
                        </div>
                      </div>
                      <div className="timeapboxalign">
                        <div className="timegapseperatebox">
                          When using A/B Testing the coldmail algorithm will
                          automatically select the best performing variant after
                          a certain number of emails have been sent.
                        </div>
                      </div>
                      <FormControl size="medium" sx={{ width: "13%" }}>
                        <Select
                          displayEmpty
                          variant="standard"
                          disableUnderline
                          value={abTestingWin}
                          onChange={(e) => {
                            setAbTestingWin(e.target.value);
                          }}
                          sx={{
                            outline: "none",
                            backgroundColor: "#FAFAFA",

                            border: "1px solid #1c485f",
                            padding: "6px 0px 6px 6px",
                            borderRadius: "4px",
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            color: "#4B4B4B",
                          }}
                          inputProps={{ "aria-label": "Without label" }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 160,
                              },
                            },
                          }}
                        >
                          {abtestingArr.map((name, index) => (
                            <MenuItem
                              disableRipple
                              disableTouchRipple
                              key={index}
                              value={name}
                              sx={{
                                borderBottom:
                                  abtestingArr.length !== index + 1 &&
                                  "1px solid #DDD",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",
                                color: "#838383",
                                padding: "12px",
                              }}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                  {selectedSchedule === "" ? (
                    <div
                      className="dailylimitbox"
                      style={{ marginBottom: "4px" }}
                    >
                      <div className="dailylimitinsidebox">
                        <div
                          style={{
                            color: "#393939",
                            fontFamily: "Source Sans 3",
                            fontWeight: 600,
                            fontStyle: "normal",
                            fontSize: "14px",
                          }}
                        >
                          Schedule{" "}
                        </div>
                        <div className="dailysubtext">
                          Specify a sending window for your campaign emails. For
                          higher email engagement, we recommend choosing a
                          schedule consistent with the recipient's working
                          hours.
                        </div>
                      </div>
                      <div
                        className="chhoseschedulebox"
                        onClick={() => {
                          setOpenScheduleDrawer(true);
                        }}
                      >
                        Choose Schedule
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        className="scheduleboxdrawer"
                        style={{
                          backgroundColor: "#D1DFE9",
                          border: "1px solid #DDD",
                        }}
                      >
                        <div className="shcedulelistbox">
                          {" "}
                          <div style={{ display: "flex" }}>
                            {selectedSchedule?.Name}
                          </div>
                        </div>
                        <div className="shedulednametext">
                          {selectedSchedule?.TimeZone}
                        </div>
                        <div className="weeknameslist">
                          {selectedSchedule?.Day.map((value) => {
                            return (
                              <div className="nameandticked">
                                {" "}
                                {!value.Active ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="23"
                                    height="23"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <rect
                                      x="0.5"
                                      y="1.46069"
                                      width="23"
                                      height="23"
                                      rx="3.5"
                                      fill="white"
                                      stroke="#1C485F"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="23"
                                    height="23"
                                    viewBox="0 0 25 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.25"
                                      width="24"
                                      height="24"
                                      rx="4"
                                      fill="#1C485F"
                                    />
                                    <path
                                      d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                                      stroke="white"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                )}{" "}
                                {value.Day}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div
                        className="chhoseschedulebox"
                        style={{
                          width: "max-content",
                        }}
                        onClick={() => {
                          setOpenScheduleDrawer(true);
                        }}
                      >
                        Change Schedule
                      </div>
                    </>
                  )}
                  <div className="dailylimitbox">
                    <div className="dailylimitinsidebox">
                      <div
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontWeight: 600,
                          fontStyle: "normal",
                          fontSize: "14px",
                        }}
                      >
                        CC and BCC
                      </div>
                      <div className="enabledisabletext">
                        {bccStatus ? (
                          <>
                            <svg
                              onClick={() => {
                                setBccStatus(!bccStatus);
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="21"
                              viewBox="0 0 40 21"
                              fill="none"
                            >
                              <rect
                                x="0.25"
                                y="1.21069"
                                width="39.5"
                                height="19.5"
                                rx="9.75"
                                fill="#F2F2F2"
                                stroke="#E5E5E5"
                                stroke-width="0.5"
                              />
                            </svg>
                            <svg
                              onClick={() => {
                                setBccStatus(!bccStatus);
                              }}
                              style={{
                                right: "38%",
                                position: "relative",
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                            >
                              <g filter="url(#filter0_d_2412_12956)">
                                <rect
                                  x="2"
                                  y="2.96069"
                                  width="16"
                                  height="16"
                                  rx="8"
                                  fill="#1C485F"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d_2412_12956"
                                  x="2"
                                  y="2.96069"
                                  width="18"
                                  height="18"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feMorphology
                                    radius="1"
                                    operator="erode"
                                    in="SourceAlpha"
                                    result="effect1_dropShadow_2412_12956"
                                  />
                                  <feOffset dx="1" dy="1" />
                                  <feGaussianBlur stdDeviation="1" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_2412_12956"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_2412_12956"
                                    result="shape"
                                  />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        ) : (
                          <>
                            <svg
                              onClick={() => {
                                setBccStatus(!bccStatus);
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="21"
                              viewBox="0 0 40 21"
                              fill="none"
                            >
                              <rect
                                x="0.25"
                                y="1.21069"
                                width="39.5"
                                height="19.5"
                                rx="9.75"
                                fill="#F2F2F2"
                                stroke="#E5E5E5"
                                stroke-width="0.5"
                              />
                            </svg>
                            <svg
                              onClick={() => {
                                setBccStatus(!bccStatus);
                              }}
                              style={{ right: "69%", position: "relative" }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                            >
                              <g filter="url(#filter0_d_2412_9894)">
                                <rect
                                  x="2"
                                  y="2.96069"
                                  width="16"
                                  height="16"
                                  rx="8"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d_2412_9894"
                                  x="2"
                                  y="2.96069"
                                  width="18"
                                  height="18"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feMorphology
                                    radius="1"
                                    operator="erode"
                                    in="SourceAlpha"
                                    result="effect1_dropShadow_2412_9894"
                                  />
                                  <feOffset dx="1" dy="1" />
                                  <feGaussianBlur stdDeviation="1" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_2412_9894"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_2412_9894"
                                    result="shape"
                                  />
                                </filter>
                              </defs>
                            </svg>
                          </>
                        )}
                      </div>
                    </div>
                    {bccStatus && (
                      <>
                        <div className="timeapboxalign">
                          <div className="timegapseperatebox">
                            Add cc and bcc reciepents to your emails
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "10px",
                            border: "1px solid #DDD",
                            display: "flex",
                            flexDirection: "row",
                            borderRadius: "6px",
                            gap: "10px",
                            width: "80%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "50%",
                            }}
                          >
                            <div
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontWeight: 600,
                                fontStyle: "normal",
                                fontSize: "14px",
                              }}
                            >
                              CC(Optional)
                            </div>
                            <div
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontSize: "14px",
                              }}
                            >
                              Send a copy of the email to the addresses listed
                              in the field
                            </div>
                          </div>
                          <textarea
                            autoComplete="off"
                            value={ccEmails}
                            onChange={(e) => {
                              setCCEmails(e.target.value);
                            }}
                            style={{
                              resize: "none",
                              backgroundColor: "#FAFAFA",
                              borderRadius: "4px",
                              padding: "12px 8px",
                              outline: "none",
                              border: "1px solid #1C485F",
                              width: "100%",
                            }}
                            name="emails"
                            id="email-addresses"
                            cols="30"
                            rows="3"
                            placeholder="Enter email address separating them with commas"
                          ></textarea>
                        </div>
                        <div
                          style={{
                            padding: "10px",
                            border: "1px solid #DDD",
                            display: "flex",
                            flexDirection: "row",
                            borderRadius: "6px",
                            gap: "10px",
                            width: "80%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "50%",
                            }}
                          >
                            <div
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontWeight: 600,
                                fontStyle: "normal",
                                fontSize: "14px",
                              }}
                            >
                              BCC(optional)
                            </div>
                            <div
                              style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontSize: "14px",
                              }}
                            >
                              Send a copy of the email to certain reciepents
                              without the other reciepients knowing about it
                            </div>
                          </div>
                          <textarea
                            autoComplete="off"
                            value={bccEmails}
                            onChange={(e) => {
                              setBccEmails(e.target.value);
                            }}
                            style={{
                              resize: "none",
                              backgroundColor: "#FAFAFA",
                              borderRadius: "4px",
                              padding: "12px 8px",
                              outline: "none",
                              border: "1px solid #1C485F",
                              width: "100%",
                            }}
                            name="emails"
                            id="email-addresses"
                            cols="30"
                            rows="3"
                            placeholder="Enter email address separating them with commas"
                          ></textarea>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="dailylimitbox">
                    <div className="dailylimitinsidebox">
                      <div
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontWeight: 600,
                          fontStyle: "normal",
                          fontSize: "14px",
                        }}
                      >
                        Campaign duration (Optional)
                      </div>
                    </div>
                    <div className="dailysubtext">
                      You can choose a start and/or end date for your campaign.
                      This way, the campaign will be automatically launched
                      and/or completed on a specific date.
                    </div>
                    <div className="enabledisabletext">
                      {campDuration ? (
                        <>
                          <svg
                            onClick={() => {
                              setCampDuration(!campDuration);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="21"
                            viewBox="0 0 40 21"
                            fill="none"
                          >
                            <rect
                              x="0.25"
                              y="1.21069"
                              width="39.5"
                              height="19.5"
                              rx="9.75"
                              fill="#F2F2F2"
                              stroke="#E5E5E5"
                              stroke-width="0.5"
                            />
                          </svg>
                          <svg
                            onClick={() => {
                              setCampDuration(!campDuration);
                            }}
                            style={{
                              right: "38%",
                              position: "relative",
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <g filter="url(#filter0_d_2412_12956)">
                              <rect
                                x="2"
                                y="2.96069"
                                width="16"
                                height="16"
                                rx="8"
                                fill="#1C485F"
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d_2412_12956"
                                x="2"
                                y="2.96069"
                                width="18"
                                height="18"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feMorphology
                                  radius="1"
                                  operator="erode"
                                  in="SourceAlpha"
                                  result="effect1_dropShadow_2412_12956"
                                />
                                <feOffset dx="1" dy="1" />
                                <feGaussianBlur stdDeviation="1" />
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_2412_12956"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_2412_12956"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </>
                      ) : (
                        <>
                          <svg
                            onClick={() => {
                              setCampDuration(!campDuration);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="21"
                            viewBox="0 0 40 21"
                            fill="none"
                          >
                            <rect
                              x="0.25"
                              y="1.21069"
                              width="39.5"
                              height="19.5"
                              rx="9.75"
                              fill="#F2F2F2"
                              stroke="#E5E5E5"
                              stroke-width="0.5"
                            />
                          </svg>
                          <svg
                            onClick={() => {
                              setCampDuration(!campDuration);
                            }}
                            style={{ right: "69%", position: "relative" }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <g filter="url(#filter0_d_2412_9894)">
                              <rect
                                x="2"
                                y="2.96069"
                                width="16"
                                height="16"
                                rx="8"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_d_2412_9894"
                                x="2"
                                y="2.96069"
                                width="18"
                                height="18"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feMorphology
                                  radius="1"
                                  operator="erode"
                                  in="SourceAlpha"
                                  result="effect1_dropShadow_2412_9894"
                                />
                                <feOffset dx="1" dy="1" />
                                <feGaussianBlur stdDeviation="1" />
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_2412_9894"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_2412_9894"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </>
                      )}
                    </div>
                    {campDuration && (
                      <div>
                        Country Time
                        <FormControl size="medium" sx={{ width: "100%" }}>
                          <Select
                            displayEmpty
                            variant="standard"
                            value={countryTimeSchedule2}
                            disableUnderline
                            onChange={(e) => {
                              setCountryTimeSchdule2(e.target.value);
                            }}
                            sx={{
                              outline: "none",
                              backgroundColor: "#FAFAFA",
                              padding: "6px 0px 6px 6px",
                              borderRadius: "4px",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              color: "#4B4B4B",
                              border: "1px solid #1C485F",
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <em
                                    style={{
                                      fontStyle: "normal",
                                      fontSize: "14px",
                                      color: "#888888",
                                    }}
                                  >
                                    Choose country time
                                  </em>
                                );
                              }
                              return selected;
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 160,
                                },
                              },
                            }}
                          >
                            {timezoneArr.map((name, index) => (
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                key={index}
                                value={name}
                                sx={{
                                  borderBottom:
                                    timezoneArr.length !== index + 1 &&
                                    "1px solid #DDD",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  color: "#838383",
                                  padding: "12px",
                                }}
                              >
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <div style={{ padding: "" }}>
                          <div style={{ display: "flex", gap: "20px" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              Start campaign on Date and Time
                              <DatePicker
                                value={campStartDate}
                                format="dd-MM-yyyy hh:mm"
                                onChange={setCampStartDate}
                                placeholder="Select Start Date"
                                placement="topEnd"
                                oneTap
                                style={{
                                  width: "76.5vw",
                                  backgroundColor: "#FAFAFA",
                                  border: "1px solid #1C485F",
                                  borderRadius: "6px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div style={{ padding: "" }}>
                          <div style={{ display: "flex", gap: "20px" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              End campaign on Date and Time
                              <DatePicker
                                value={campEndDate}
                                format="dd-MM-yyyy hh:mm"
                                onChange={setCampEndDate}
                                placeholder="Select End Date"
                                placement="topEnd"
                                oneTap
                                style={{
                                  width: "76.5vw",
                                  backgroundColor: "#FAFAFA",
                                  border: "1px solid #1C485F",
                                  borderRadius: "6px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {type === "review" && (
              <div
                style={{
                  // paddingBottom: "30px",
                  height: "100%",
                  display: "flex",
                  overflow: "auto",
                  position: "relative",
                }}
              >
                {locData.state.isEnableSequence ? (
                  <div style={{ padding: "10px", height: "100%", flexGrow: 1 }}>
                    <div
                      // className="grid grid-cols-12 gap-4"
                      style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{ height: "100%", overflow: "auto" }}
                        // className="col-span-5"
                      >
                        <ul
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "6px",
                          }}
                        >
                          {sequenceData.length !== 0 &&
                            sequenceData.map((data, i) => {
                              if (i === 0) {
                                return null;
                              }
                              if (data.data.label === "email") {
                                stepCounter++;
                              }
                              return (
                                <div
                                  style={{
                                    borderTopLeftRadius:
                                      data.data.label === "email" && "8px",
                                    borderTopRightRadius:
                                      data.data.label === "email" && "8px",
                                    borderBottomLeftRadius:
                                      data.data.label === "Delay" && "8px",
                                    borderBottomRightRadius:
                                      data.data.label === "Delay" && "8px",
                                    marginBottom:
                                      data.data.label === "Delay" && "12px",
                                    minWidth: "300px",
                                  }}
                                >
                                  <div
                                    style={{
                                      // borderBottom: "1px solid #DDD",
                                      backgroundColor: "#f9f9f9",
                                      borderTopLeftRadius: "8px",
                                      borderTopRightRadius: "8px",
                                    }}
                                  >
                                    {data.data.label === "email" && (
                                      <>
                                        <div
                                          style={{
                                            padding: "8px 6px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            padding: "10px 6px",
                                            borderBottom: "1px solid #DDD",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: "#000",
                                              fontFamily: "Source Sans 3",
                                              fontSize: "14px",
                                              fontWeight: 700,
                                              marginBottom: 0,
                                              fontStyle: "normal",
                                            }}
                                          >
                                            Step {stepCounter}
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "14px",
                                            padding: "12px 10px",
                                          }}
                                        >
                                          <p
                                            style={{
                                              color: "#393939",
                                              fontFamily: "Source Sans 3",
                                              width: "100%",
                                              height: "max-content",
                                              overflowX: "auto",
                                              fontSize: "14px",
                                              fontWeight: 700,
                                              marginBottom: 0,
                                              fontStyle: "normal",
                                              backgroundColor: "#FFF",
                                              padding: data.BackendData.data
                                                .subject
                                                ? "6px"
                                                : "16px",
                                              borderRadius: 5,
                                              border: "1px solid #DDD",
                                            }}
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                data.BackendData.data.subject,
                                            }}
                                          />
                                          <FormControlLabel
                                            sx={{
                                              marginRight: "0px",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                            control={
                                              <Switch
                                                checked={
                                                  data.BackendData.data
                                                    .ABTesting
                                                }
                                                style={{
                                                  color: "#1c485f",
                                                  marginRight: "0px",
                                                }}
                                              />
                                            }
                                            label="A/B Testing"
                                          />
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  {data.data.label === "Delay" && (
                                    <div
                                      style={{
                                        borderTop:
                                          i !== sequenceData.length - 1 &&
                                          "1px solid #DDD",
                                        backgroundColor: "#f9f9f9",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 5,
                                        padding: "10px 6px",
                                        borderBottomLeftRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                      }}
                                    >
                                      {i !== sequenceData.length - 1 && (
                                        <>
                                          <p>Delay</p>
                                          <input
                                            disabled
                                            type="text"
                                            style={{
                                              outline: "none",
                                              width: "46px",
                                              padding: "6px",
                                              backgroundColor: "#FFF",
                                              border: "1px solid #DDD",
                                              borderRadius: 5,
                                            }}
                                            value={data.BackendData.data.count}
                                          />
                                          <p>Days</p>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      overflow: "auto",
                      // backgroundColor:'red'
                    }}
                  >
                    <img
                      src={imageSrc}
                      alt=""
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                )}

                <div
                  // style={{ width: window.innerWidth / 2.19 }}
                  style={{
                    width: "300px",
                    position: "sticky",
                  }}
                  className="reviewwpagebox"
                >
                  <div className="prospectheadingstyle">Review Campaign</div>
                  <div
                    className="reviwcontenttotal"
                    style={{
                      padding: "20px",
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    <div
                      className="revieicampname"
                      style={{
                        border: "1px solid #1C485F",
                        backgroundColor: "#D1DFE9",
                      }}
                    >
                      <div className="hedingcampagnreview">Campaign name</div>
                      <div>{locData.state.campaignName}</div>
                    </div>
                    <div
                      className="reviewsender"
                      style={{
                        border: "1px solid #1C485F",
                        backgroundColor: "#D1DFE9",
                      }}
                    >
                      <div className="insoidereviewsender">
                        <div className="hedingcampagnreview">
                          Sending to list:
                        </div>
                        <div>
                          {nameListArr.map((val) => {
                            if (val._id === nameListId) {
                              return val.Name;
                            }
                          })}
                        </div>
                      </div>
                    </div>
                    <div
                      className="reviewsender"
                      style={{
                        border: "1px solid #1C485F",
                        backgroundColor: "#D1DFE9",
                      }}
                    >
                      <div className="insoidereviewsender">
                        <div className="hedingcampagnreview">
                          Sender account:
                        </div>
                        <div>
                          {senderMails.map((val) => {
                            if (accountList.includes(val._id)) {
                              return <div>{val.FromEmail}</div>;
                            }
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Modal
              open={open3}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              {selected === "email" ? (
                <div className="modalPopup2" style={{ height: "100vh" }}>
                  <DrawerClassCampaign
                    subject={subject}
                    setSubject={setSubject}
                    subjectB={subjectB}
                    setSubjectB={setSubjectB}
                    setEmailBody={setEmailBody}
                    emailBody={emailBody}
                    setEmailBodyB={setEmailBodyB}
                    emailBodyB={emailBodyB}
                    createEmailForNode={createEmailForNode}
                    setOpen3={setOpen3}
                    setLocalStorageData={setLocalStorageData}
                    setABTestingStatus={setABTestingStatus}
                    abTestingStatus={abTestingStatus}
                    variableArray={variableArray}
                  />
                </div>
              ) : (
                <>
                  {selected === "Trigger" ? (
                    <div
                      className="modalPopup2"
                      style={{
                        width: window.innerWidth / 1.9,
                        height: window.innerHeight,
                        overflowY: "scroll",
                      }}
                    >
                      <div className="emailboxx">Add a trigger</div>
                      <div
                        className="triggerbodystylebox"
                        style={{
                          height: window.innerHeight / 1.9,
                          width: window.innerWidth / 1.88,
                        }}
                      >
                        <div
                          style={{
                            padding: "0px 12px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <div className="triggerdescription">
                            <div className="triggerdesc1">
                              {" "}
                              Triggers help sort interested List from unengaged
                              recipients.
                            </div>
                            <div className="triggerdesc2">
                              *The campaign will stop for a prospect once they
                              reply*
                            </div>
                          </div>
                          <div className="triggerroundedboxstyling">
                            Add a trigger
                            <div className="triggerrounded">
                              <div className="radioboxstyle">
                                <FormControlLabel
                                  value="opened"
                                  control={
                                    <Radio style={{ color: "#1C485F" }} />
                                  }
                                  label="Opened email"
                                  onClick={(e) => {
                                    setTriggerValue(e.target.value);
                                  }}
                                  checked={triggerValue === "opened"}
                                />
                              </div>
                              <div className="radioboxstyle">
                                <FormControlLabel
                                  value="Clicked"
                                  control={
                                    <Radio style={{ color: "#1C485F" }} />
                                  }
                                  label="Clicked on a link"
                                  onClick={(e) => {
                                    setTriggerValue(e.target.value);
                                  }}
                                  checked={triggerValue === "Clicked"}
                                />
                                <FormControlLabel
                                  value="Calendly"
                                  control={
                                    <Radio style={{ color: "#1C485F" }} />
                                  }
                                  label="Booked a meeting via Calendly"
                                  onClick={(e) => {
                                    setTriggerValue(e.target.value);
                                  }}
                                  checked={triggerValue === "Calendly"}
                                />
                              </div>
                            </div>
                            <div className="waitingtimeboxemail">
                              <div className="waitingtext">Waiting Time</div>
                              <div className="delaytimingbox">
                                <div
                                  className="incrementdecreamentbox"
                                  style={{ border: "1px solid #1C485F" }}
                                >
                                  <svg
                                    onClick={() => {
                                      if (count > 0) {
                                        setCount(count - 1);
                                      }
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="21"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                  >
                                    <path
                                      d="M6.66699 10.9607H13.3337"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.50033 19.294H12.5003C16.667 19.294 18.3337 17.6274 18.3337 13.4607V8.46071C18.3337 4.29405 16.667 2.62738 12.5003 2.62738H7.50033C3.33366 2.62738 1.66699 4.29405 1.66699 8.46071V13.4607C1.66699 17.6274 3.33366 19.294 7.50033 19.294Z"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  {count}
                                  <svg
                                    onClick={() => {
                                      if (waiting === "Days") {
                                        if (count <= 90) {
                                          setCount(count + 1);
                                        }
                                      } else if (waiting === "Hours") {
                                        if (count <= 2160) {
                                          setCount(count + 1);
                                        }
                                      } else if (waiting === "Minutes") {
                                        if (count <= 129600) {
                                          setCount(count + 1);
                                        }
                                      }
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="21"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                  >
                                    <path
                                      d="M6.66699 10.9607H13.3337"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10 14.294V7.62738"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.50033 19.294H12.5003C16.667 19.294 18.3337 17.6274 18.3337 13.4607V8.46071C18.3337 4.29405 16.667 2.62738 12.5003 2.62738H7.50033C3.33366 2.62738 1.66699 4.29405 1.66699 8.46071V13.4607C1.66699 17.6274 3.33366 19.294 7.50033 19.294Z"
                                      stroke="#393939"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                                <FormControl
                                  size="medium"
                                  sx={{ width: "100%" }}
                                >
                                  <Select
                                    displayEmpty
                                    variant="standard"
                                    disableUnderline
                                    sx={{
                                      color: "var(--color-dark-600, #727272)",
                                      fontFamily: "Source Sans 3",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: 400,
                                      outline: "none",
                                      backgroundColor: "#FAFAFA",
                                      borderRadius: "4px",
                                      border: "1px solid #1C485F",
                                      padding: "8px",
                                    }}
                                    value={waiting}
                                    onChange={handleChange}
                                    IconComponent={ArrowDropDownIcon}
                                  >
                                    <MenuItem
                                      sx={{
                                        color: "var(--color-dark-600, #727272)",
                                        fontFamily: "Source Sans 3",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                      }}
                                      value="Days"
                                    >
                                      Days
                                    </MenuItem>
                                    <MenuItem
                                      sx={{
                                        color: "var(--color-dark-600, #727272)",
                                        fontFamily: "Source Sans 3",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "20px",
                                      }}
                                      value="Hours"
                                    >
                                      Hours
                                    </MenuItem>
                                    {/* <MenuItem
                                  sx={{
                                    color: "var(--color-dark-600, #727272)",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                  }}
                                  value="Minutes"
                                >
                                  Minutes
                                </MenuItem> */}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="bootomsavebutton"
                          style={{
                            bottom: 0,
                            position: "absolute",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="savebottombutt"
                            onClick={() => {
                              createTriggerValue();
                            }}
                          >
                            Save
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {selected === "Delay" ? (
                        <div
                          className="modalPopup2"
                          style={{
                            width: "47vw",
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div className="emailboxx" style={{ flexShrink: 0 }}>
                            Set a delay
                          </div>
                          <div
                            className="triggerbodystylebox"
                            style={{
                              flexGrow: 1,
                              overflowY: "scroll",
                              display: "flex",
                              flexDirection: "column",
                              padding: "16px",
                            }}
                          >
                            <div className="triggerdescription">
                              <div className="triggerdesc1">
                                {" "}
                                Delay the next email in the chain to create a
                                natural pause.
                              </div>
                              <div className="triggerdesc2">
                                *The campaign will stop for a prospect once they
                                reply*
                              </div>
                            </div>

                            <div className="waitingtimeboxemail">
                              <div className="waitingtimeboxemail">
                                <div className="waitingtext">Waiting Time</div>
                                <div className="delaytimingbox">
                                  <div
                                    className="incrementdecreamentbox"
                                    style={{ border: "1px solid #1C485F" }}
                                  >
                                    <svg
                                      onClick={() => {
                                        if (count1 > 0) {
                                          setCount1(count1 - 1);
                                        }
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="21"
                                      viewBox="0 0 20 21"
                                      fill="none"
                                    >
                                      <path
                                        d="M6.66699 10.9607H13.3337"
                                        stroke="#393939"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.50033 19.294H12.5003C16.667 19.294 18.3337 17.6274 18.3337 13.4607V8.46071C18.3337 4.29405 16.667 2.62738 12.5003 2.62738H7.50033C3.33366 2.62738 1.66699 4.29405 1.66699 8.46071V13.4607C1.66699 17.6274 3.33366 19.294 7.50033 19.294Z"
                                        stroke="#393939"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    {count1}
                                    <svg
                                      onClick={() => {
                                        if (waitingDelay === "Days") {
                                          if (count1 <= 90) {
                                            setCount1(count1 + 1);
                                          }
                                        } else if (waitingDelay === "Hours") {
                                          if (count <= 2160) {
                                            setCount1(count1 + 1);
                                          }
                                        } else if (waitingDelay === "Minutes") {
                                          if (count1 <= 129600) {
                                            setCount1(count1 + 1);
                                          }
                                        }
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="21"
                                      viewBox="0 0 20 21"
                                      fill="none"
                                    >
                                      <path
                                        d="M6.66699 10.9607H13.3337"
                                        stroke="#393939"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M10 14.294V7.62738"
                                        stroke="#393939"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.50033 19.294H12.5003C16.667 19.294 18.3337 17.6274 18.3337 13.4607V8.46071C18.3337 4.29405 16.667 2.62738 12.5003 2.62738H7.50033C3.33366 2.62738 1.66699 4.29405 1.66699 8.46071V13.4607C1.66699 17.6274 3.33366 19.294 7.50033 19.294Z"
                                        stroke="#393939"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                  <FormControl
                                    size="medium"
                                    sx={{ width: "100%" }}
                                  >
                                    <Select
                                      displayEmpty
                                      variant="standard"
                                      disableUnderline
                                      sx={{
                                        color: "var(--color-dark-600, #727272)",
                                        fontFamily: "Source Sans 3",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        outline: "none",
                                        backgroundColor: "#FAFAFA",
                                        borderRadius: "4px",
                                        border: "1px solid #1C485F",
                                        padding: "8px",
                                      }}
                                      value={waitingDelay}
                                      onChange={handleChange5}
                                      IconComponent={ArrowDropDownIcon}
                                    >
                                      <MenuItem
                                        sx={{
                                          color:
                                            "var(--color-dark-600, #727272)",
                                          fontFamily: "Source Sans 3",
                                          fontSize: "14px",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                        }}
                                        value="Days"
                                      >
                                        Days
                                      </MenuItem>
                                      <MenuItem
                                        sx={{
                                          color:
                                            "var(--color-dark-600, #727272)",
                                          fontFamily: "Source Sans 3",
                                          fontSize: "14px",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          lineHeight: "20px",
                                        }}
                                        value="Hours"
                                      >
                                        Hours
                                      </MenuItem>
                                      <MenuItem
                                        sx={{
                                          color:
                                            "var(--color-dark-600, #727272)",
                                          fontFamily: "Source Sans 3",
                                          fontSize: "14px",
                                          fontStyle: "normal",
                                          fontWeight: 400,
                                          lineHeight: "20px",
                                        }}
                                        value="Minutes"
                                      >
                                        Minutes
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="bootomsavebutton"
                            style={{
                              padding: "12px 16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="savebottombutt"
                              onClick={() => {
                                createDelayvalues();
                              }}
                            >
                              Save
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {selected === "Goal" ? (
                            <div
                              className="modalPopup2"
                              style={{
                                width: "47vw",
                                height: "100vh",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                className="emailboxx"
                                style={{ flexShrink: 0 }}
                              >
                                Set a goal
                              </div>
                              <div
                                className="triggerbodystylebox"
                                style={{
                                  flexGrow: 1,
                                  overflowY: "scroll",
                                  display: "flex",
                                  flexDirection: "column",
                                  padding: "16px",
                                }}
                              >
                                <div className="triggerdescription">
                                  <div className="triggerdesc1">
                                    Add a goal at the end of each email sequence
                                    to see how many recipients reach it and
                                    filter out those who don't. This is
                                    especially useful when you have multiple
                                    email flows within one campaign.
                                  </div>
                                </div>
                                <div className="goaldesignBox">
                                  Goal name
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    value={goalName}
                                    onChange={(e) => {
                                      setGoalName(e.target.value);
                                    }}
                                    placeholder="Ex: Interested or not interested"
                                    style={{
                                      padding: "10px",
                                      outline: "none",
                                      width: "100%",
                                      backgroundColor: "#FAFAFA",
                                      border: "1px solid #1C485F",
                                      borderRadius: "4px",
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className="bootomsavebutton"
                                style={{
                                  padding: "12px 16px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  className="savebottombutt"
                                  onClick={() => {
                                    createGoalValues();
                                  }}
                                >
                                  Save
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              {selected === "schedule" ? (
                                <div
                                  className="modalPopup2"
                                  style={{
                                    width: "47vw",
                                    height: "100vh",
                                    // overflowY: "scroll",
                                  }}
                                >
                                  {newSchedule ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                      }}
                                    >
                                      <div
                                        className="emailboxx"
                                        style={{ flexShrink: 0 }}
                                      >
                                        Schedule
                                      </div>
                                      <div
                                        // className="outerschedulebox"
                                        style={{
                                          flexGrow: 1,
                                          overflowY: "scroll",
                                          display: "flex",
                                          flexDirection: "column",
                                          padding: "16px",
                                        }}
                                      >
                                        <div
                                          className="shcedulenamecreationbox"
                                          style={{
                                            marginBottom: "14px",
                                            boxShadow:
                                              "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            padding: "14px",
                                          }}
                                        >
                                          Schedule name
                                          <div
                                            style={{
                                              flexGrow: 1,
                                              width: "100%",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              style={{
                                                padding: "10px",
                                                outline: "none",
                                                width: "100%",
                                                backgroundColor: "#FAFAFA",
                                                border: "1px solid #1C485F",
                                                borderRadius: "4px",
                                              }}
                                              autoComplete="off"
                                              value={shceduleName}
                                              onChange={(e) => {
                                                setScheduleName(e.target.value);
                                              }}
                                              placeholder="Ex:New schedule"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="scheduleinlinebox"
                                          style={{
                                            boxShadow:
                                              "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            padding: "14px",
                                          }}
                                        >
                                          Country Time
                                          <div style={{ flexGrow: 1 }}>
                                            <Autocomplete
                                              displayEmpty
                                              variant="standard"
                                              value={countryTimeSchedule}
                                              disableUnderline
                                              options={timezoneArr}
                                              onChange={handleChange9}
                                              sx={{
                                                backgroundColor: "#FAFAFA",

                                                borderRadius: "4px",
                                                fontFamily: "Source Sans 3",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                color: "#4B4B4B",
                                                maxHeight: 160,
                                                overflowY: "auto",
                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                  {
                                                    borderColor: "#eee",
                                                  },
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  placeholder="Choose country time"
                                                  sx={{
                                                    outline: "none",
                                                  }}
                                                  {...params}
                                                />
                                              )}
                                              inputProps={{
                                                "aria-label": "Without label",
                                              }}
                                              MenuProps={{
                                                PaperProps: {
                                                  style: {
                                                    height: 160,
                                                    overflowY: "auto",
                                                  },
                                                },
                                              }}
                                            ></Autocomplete>
                                          </div>
                                          <div>
                                            <div className="shceduledayfrombox">
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    "repeat(3,1fr)",
                                                  gap: "16px",
                                                  marginTop: "14px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontFamily: "Source Sans 3",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    color: "#4B4B4B",
                                                    fontWeight: 700,
                                                    width: "155px",
                                                  }}
                                                >
                                                  Days
                                                </div>
                                                <div
                                                  style={{
                                                    fontFamily: "Source Sans 3",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    color: "#4B4B4B",
                                                    fontWeight: 700,
                                                  }}
                                                >
                                                  From
                                                </div>
                                                <div
                                                  style={{
                                                    fontFamily: "Source Sans 3",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    color: "#4B4B4B",
                                                    fontWeight: 700,
                                                  }}
                                                >
                                                  To
                                                </div>
                                              </div>
                                              <div className="weeksdaysbox">
                                                {daylistArr.map((val, idx) => {
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        gridTemplateColumns:
                                                          "repeat(3,1fr)",
                                                        gap: "16px",
                                                      }}
                                                    >
                                                      <FormControlLabel
                                                        sx={{ width: "100%" }}
                                                        value={val.Day}
                                                        control={
                                                          <Checkbox
                                                            checked={val.Active}
                                                            style={{
                                                              color: "#1C485F",
                                                            }}
                                                          />
                                                        }
                                                        label={val.Day}
                                                        onClick={(e) => {
                                                          val.Active =
                                                            !val.Active;
                                                          setDayListArr([
                                                            ...daylistArr,
                                                          ]);
                                                        }}
                                                      />
                                                      <FormControl
                                                        size="medium"
                                                        sx={{ width: "100%" }}
                                                      >
                                                        <Select
                                                          displayEmpty
                                                          variant="standard"
                                                          disableUnderline
                                                          value={val.StartHour}
                                                          onChange={(e) => {
                                                            val.StartHour =
                                                              e.target.value;
                                                            setDayListArr([
                                                              ...daylistArr,
                                                            ]);
                                                          }}
                                                          sx={{
                                                            outline: "none",
                                                            backgroundColor:
                                                              "#FAFAFA",
                                                            padding:
                                                              "6px 0px 6px 6px",
                                                            opacity:
                                                              !val.Active &&
                                                              "0.3",
                                                            pointerEvents:
                                                              !val.Active &&
                                                              "none",
                                                            border:
                                                              "1px solid #1c485f",
                                                            borderRadius: "4px",
                                                            fontFamily:
                                                              "Source Sans 3",
                                                            fontSize: "14px",
                                                            fontStyle: "normal",
                                                            fontWeight: 400,
                                                            color: "#4B4B4B",
                                                          }}
                                                          renderValue={(
                                                            selected
                                                          ) => {
                                                            if (
                                                              selected.length ===
                                                              0
                                                            ) {
                                                              return (
                                                                <em
                                                                  style={{
                                                                    fontStyle:
                                                                      "normal",
                                                                    fontSize:
                                                                      "14px",
                                                                    color:
                                                                      "#888888",
                                                                  }}
                                                                >
                                                                  Choose country
                                                                  time
                                                                </em>
                                                              );
                                                            }
                                                            return selected;
                                                          }}
                                                          inputProps={{
                                                            "aria-label":
                                                              "Without label",
                                                          }}
                                                          MenuProps={{
                                                            PaperProps: {
                                                              style: {
                                                                maxHeight: 160,
                                                              },
                                                            },
                                                          }}
                                                        >
                                                          {timeList.map(
                                                            (name, index) => (
                                                              <MenuItem
                                                                disableRipple
                                                                disableTouchRipple
                                                                key={index}
                                                                value={name}
                                                                sx={{
                                                                  borderBottom:
                                                                    timezoneArr.length !==
                                                                      index +
                                                                        1 &&
                                                                    "1px solid #DDD",
                                                                  fontFamily:
                                                                    "Source Sans 3",
                                                                  fontSize:
                                                                    "14px",
                                                                  fontWeight: 400,
                                                                  fontStyle:
                                                                    "normal",
                                                                  color:
                                                                    "#838383",
                                                                  padding:
                                                                    "12px",
                                                                }}
                                                              >
                                                                {name}
                                                              </MenuItem>
                                                            )
                                                          )}
                                                        </Select>
                                                      </FormControl>
                                                      <FormControl
                                                        size="medium"
                                                        sx={{ width: "100%" }}
                                                      >
                                                        <Select
                                                          displayEmpty
                                                          variant="standard"
                                                          disableUnderline
                                                          value={val.EndHour}
                                                          onChange={(e) => {
                                                            val.EndHour =
                                                              e.target.value;
                                                            setDayListArr([
                                                              ...daylistArr,
                                                            ]);
                                                          }}
                                                          sx={{
                                                            outline: "none",
                                                            backgroundColor:
                                                              "#FAFAFA",
                                                            opacity:
                                                              !val.Active &&
                                                              "0.3",
                                                            pointerEvents:
                                                              !val.Active &&
                                                              "none",
                                                            border:
                                                              "1px solid #1c485f",
                                                            padding:
                                                              "6px 0px 6px 6px",
                                                            borderRadius: "4px",
                                                            fontFamily:
                                                              "Source Sans 3",
                                                            fontSize: "14px",
                                                            fontStyle: "normal",
                                                            fontWeight: 400,
                                                            color: "#4B4B4B",
                                                          }}
                                                          renderValue={(
                                                            selected
                                                          ) => {
                                                            if (
                                                              selected.length ===
                                                              0
                                                            ) {
                                                              return (
                                                                <em
                                                                  style={{
                                                                    fontStyle:
                                                                      "normal",
                                                                    fontSize:
                                                                      "14px",
                                                                    color:
                                                                      "#888888",
                                                                  }}
                                                                >
                                                                  Choose country
                                                                  time
                                                                </em>
                                                              );
                                                            }
                                                            return selected;
                                                          }}
                                                          inputProps={{
                                                            "aria-label":
                                                              "Without label",
                                                          }}
                                                          MenuProps={{
                                                            PaperProps: {
                                                              style: {
                                                                maxHeight: 160,
                                                              },
                                                            },
                                                          }}
                                                        >
                                                          {timeList.map(
                                                            (name, index) => (
                                                              <MenuItem
                                                                disableRipple
                                                                disableTouchRipple
                                                                key={index}
                                                                value={name}
                                                                sx={{
                                                                  borderBottom:
                                                                    timezoneArr.length !==
                                                                      index +
                                                                        1 &&
                                                                    "1px solid #DDD",
                                                                  fontFamily:
                                                                    "Source Sans 3",
                                                                  fontSize:
                                                                    "14px",
                                                                  fontWeight: 400,
                                                                  fontStyle:
                                                                    "normal",
                                                                  color:
                                                                    "#838383",
                                                                  padding:
                                                                    "12px",
                                                                }}
                                                              >
                                                                {name}
                                                              </MenuItem>
                                                            )
                                                          )}
                                                        </Select>
                                                      </FormControl>

                                                      {/* <FormControl
                          variant="filled"
                          sx={{
                            m: 1,
                            minWidth: 120,
                            borderBottom: "none",
                            opacity: !val.Active && "0.3",
                            pointerEvents: !val.Active && "none",
                          }}
                        >
                          <Select
                            disableUnderline
                            sx={{
                              color: "var(--color-dark-600, #727272)",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "20px",
                            }}
                            labelId="demo-simple-select-filled-label"
                            id="demo-simple-select-filled"
                            value={val.StartHour}
                            onChange={(e) => {
                              val.StartHour = e.target.value;
                              setDayListArr([...daylistArr]);
                            }}
                            IconComponent={ArrowDropDownIcon}
                          >
                            {timeList.map((val) => {
                              return (
                                <MenuItem
                                  sx={{
                                    color: "var(--color-dark-600, #727272)",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                  }}
                                  value={val}
                                >
                                  {val}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl> */}
                                                      {/* <FormControl
                          variant="filled"
                          sx={{
                            m: 1,
                            minWidth: 120,
                            borderBottom: "none",
                            opacity: !val.Active && "0.3",
                            pointerEvents: !val.Active && "none",
                          }}
                        >
                          <Select
                            disableUnderline
                            sx={{
                              color: "var(--color-dark-600, #727272)",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "20px",
                            }}
                            labelId="demo-simple-select-filled-label"
                            id="demo-simple-select-filled"
                            value={val.EndHour}
                            onChange={(e) => {
                              val.EndHour = e.target.value;
                              setDayListArr([...daylistArr]);
                            }}
                            IconComponent={ArrowDropDownIcon}
                          >
                            {timeList.map((val) => {
                              return (
                                <MenuItem
                                  sx={{
                                    color: "var(--color-dark-600, #727272)",
                                    fontFamily: "Source Sans 3",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                  }}
                                  value={val}
                                >
                                  {val}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl> */}
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="schedulefooter">
                                        <div className="cancelconfirmbuttonbox">
                                          <div
                                            onClick={() => {
                                              setNewSchedule(false);
                                            }}
                                            className="cancelbyutnschedule"
                                          >
                                            Cancel
                                          </div>
                                          <div
                                            onClick={() => {
                                              if (updateStatus) {
                                                updateSchedule();
                                              } else {
                                                createSchedule();
                                              }
                                            }}
                                            className="confirmshcedulepink"
                                            style={{
                                              pointerEvents:
                                                (countryTimeSchedule === null ||
                                                  shceduleName === "") &&
                                                "none",
                                              // opacity:
                                              //   countryTimeSchedule !== null &&
                                              //   shceduleName !== "" &&
                                              //   daylistArr.some(
                                              //     (item) => item.Active === true
                                              //   )
                                              //     ? 1
                                              //     : 0.4,
                                            }}
                                          >
                                            {updateStatus ? "Update" : "Save"}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                      }}
                                    >
                                      <div
                                        className="emailboxx"
                                        style={{ flexShrink: 0 }}
                                      >
                                        Schedule
                                      </div>
                                      <div
                                        style={{
                                          flexGrow: 1,
                                          overflowY: "scroll",
                                          backgroundColor: "Background",
                                          display: "flex",
                                          flexDirection: "column",
                                          padding: "16px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <p>Click and select the schedule</p>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              gap: "10px",
                                            }}
                                          >
                                            {scheduleData.map((val) => {
                                              return (
                                                <div
                                                  className="scheduleboxdrawer"
                                                  onClick={() => {
                                                    setSelectedSchedule(val);
                                                  }}
                                                  style={{
                                                    backgroundColor:
                                                      selectedSchedule._id ===
                                                        val._id && "#D1DFE9",
                                                    border:
                                                      selectedSchedule._id ===
                                                      val._id
                                                        ? "1px solid var(--color-success, #53D86A)"
                                                        : "1px solid #DDD",
                                                  }}
                                                >
                                                  <div className="shcedulelistbox">
                                                    {" "}
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      {selectedSchedule._id ===
                                                        val._id && (
                                                        <img
                                                          src={fillgreen}
                                                          alt=""
                                                          style={{
                                                            marginTop: "-6px",
                                                          }}
                                                        />
                                                      )}
                                                      {val.Name}
                                                    </div>
                                                    <div className="shcedulerightsideicom">
                                                      <svg
                                                        onClick={() => {
                                                          setOpen6(true);
                                                        }}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="21"
                                                        viewBox="0 0 20 21"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M7.08594 5.10232L7.26927 4.01065C7.4026 3.21899 7.5026 2.62732 8.91094 2.62732H11.0943C12.5026 2.62732 12.6109 3.25232 12.7359 4.01899L12.9193 5.10232"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M15.7057 8.57739L15.1641 16.9691C15.0724 18.2774 14.9974 19.2941 12.6724 19.2941H7.3224C4.9974 19.2941 4.9224 18.2774 4.83073 16.9691L4.28906 8.57739"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M8.60938 14.7107H11.3844"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M7.91406 11.3773H12.0807"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                      </svg>
                                                      <svg
                                                        onClick={() => {
                                                          setUpdateStatus(true);
                                                          setNewSchedule(true);
                                                          setScheduleName(
                                                            val.Name
                                                          );
                                                          setCountryTimeSchdule(
                                                            val.TimeZone
                                                          );
                                                          let vikki = val.Day;
                                                          vikki.map((value) => {
                                                            value.EndHour =
                                                              convertTo12HourFormat(
                                                                parseInt(
                                                                  value.EndHour
                                                                )
                                                              );
                                                            value.StartHour =
                                                              convertTo12HourFormat(
                                                                parseInt(
                                                                  value.StartHour
                                                                )
                                                              );
                                                            delete value._id;
                                                          });
                                                          setDayListArr(vikki);
                                                        }}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="21"
                                                        viewBox="0 0 20 21"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M9.16406 2.62732H7.4974C3.33073 2.62732 1.66406 4.29399 1.66406 8.46065V13.4607C1.66406 17.6273 3.33073 19.294 7.4974 19.294H12.4974C16.6641 19.294 18.3307 17.6273 18.3307 13.4607V11.794"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M13.3675 3.47733L6.80088 10.044C6.55088 10.294 6.30088 10.7857 6.25088 11.144L5.89254 13.6523C5.75921 14.5607 6.40088 15.194 7.30921 15.069L9.81754 14.7107C10.1675 14.6607 10.6592 14.4107 10.9175 14.1607L17.4842 7.59399C18.6175 6.46066 19.1509 5.14399 17.4842 3.47733C15.8175 1.81066 14.5009 2.34399 13.3675 3.47733Z"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-miterlimit="10"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                        <path
                                                          d="M12.4219 4.41907C12.9802 6.41073 14.5385 7.96907 16.5385 8.53573"
                                                          stroke="black"
                                                          stroke-width="1.5"
                                                          stroke-miterlimit="10"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="shedulednametext"
                                                    style={{
                                                      border:
                                                        "1px solid #1C485F",
                                                    }}
                                                  >
                                                    {val.TimeZone}
                                                  </div>
                                                  <div className="weeknameslist">
                                                    {val.Day.map((value) => {
                                                      return (
                                                        <div className="nameandticked">
                                                          {" "}
                                                          {!value.Active ? (
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="13"
                                                              height="13"
                                                              viewBox="0 0 24 25"
                                                              fill="none"
                                                            >
                                                              <rect
                                                                x="0.5"
                                                                y="1.46069"
                                                                width="23"
                                                                height="23"
                                                                rx="3.5"
                                                                fill="white"
                                                                stroke="#1C485F"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              width="13"
                                                              height="13"
                                                              viewBox="0 0 25 24"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <rect
                                                                x="0.25"
                                                                width="24"
                                                                height="24"
                                                                rx="4"
                                                                fill="#1C485F"
                                                              />
                                                              <path
                                                                d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                                                                stroke="white"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                              />
                                                            </svg>
                                                          )}{" "}
                                                          {value.Day}
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                          <div
                                            className="createschedulebutton"
                                            onClick={() => {
                                              setNewSchedule(true);
                                              setScheduleName("");
                                              setCountryTimeSchdule(null);
                                              setUpdateStatus(false);
                                            }}
                                            style={{
                                              alignSelf: "flex-start",
                                            }}
                                          >
                                            Create New Schedule
                                          </div>
                                        </div>
                                      </div>
                                      <div className="schedulefooter">
                                        <div className="cancelconfirmbuttonbox">
                                          <div
                                            onClick={() => {
                                              setOpen3(false);
                                            }}
                                            className="cancelbyutnschedule"
                                          >
                                            Cancel
                                          </div>
                                          {/* {selectedSchedule === "" ? (
                                          <div className="confirmbuttonschedule">
                                            Confirm
                                          </div>
                                        ) : (
                                          <div
                                            onClick={() => {
                                              setOpen3(false);
                                            }}
                                            className="confirmshcedulepink"
                                          >
                                            Confirm
                                          </div>
                                        )} */}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div
                                  className="modalPopup2"
                                  style={{
                                    width: window.innerWidth / 1.9,
                                    height: window.innerHeight / 0.98,
                                    overflowY: "scroll",
                                  }}
                                >
                                  <div className="emailboxx">
                                    Add email account
                                  </div>
                                  <div className="addnewaccoiuntcss">
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="45"
                                        height="46"
                                        viewBox="0 0 45 46"
                                        fill="none"
                                      >
                                        <path
                                          d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
                                          fill="#EA4435"
                                        />
                                        <path
                                          d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
                                          fill="#00AC47"
                                        />
                                        <path
                                          d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
                                          fill="#FFBA00"
                                        />
                                        <path
                                          d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
                                          fill="#4285F4"
                                        />
                                        <path
                                          d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
                                          fill="#C52528"
                                        />
                                      </svg>
                                    </div>
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="32"
                                        height="33"
                                        viewBox="0 0 32 33"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_2212_13112)">
                                          <path
                                            d="M17 15.9607H32V1.96069C32 1.69548 31.8946 1.44112 31.7071 1.25359C31.5196 1.06605 31.2652 0.960693 31 0.960693H17V15.9607Z"
                                            fill="#4CAF50"
                                          />
                                          <path
                                            d="M15 15.9607V0.960693H1C0.734784 0.960693 0.48043 1.06605 0.292893 1.25359C0.105357 1.44112 0 1.69548 0 1.96069L0 15.9607H15Z"
                                            fill="#F44336"
                                          />
                                          <path
                                            d="M15 17.9607H0V31.9607C0 32.2259 0.105357 32.4803 0.292893 32.6678C0.48043 32.8553 0.734784 32.9607 1 32.9607H15V17.9607Z"
                                            fill="#2196F3"
                                          />
                                          <path
                                            d="M17 17.9607V32.9607H31C31.2652 32.9607 31.5196 32.8553 31.7071 32.6678C31.8946 32.4803 32 32.2259 32 31.9607V17.9607H17Z"
                                            fill="#FFC107"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2212_13112">
                                            <rect
                                              width="32"
                                              height="32"
                                              fill="white"
                                              transform="translate(0 0.960693)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="86"
                                        height="28"
                                        viewBox="0 0 86 28"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_2212_13177)">
                                          <path
                                            d="M85.989 6.71143V25.2301L83.168 27.7318V9.60973L85.989 6.71143Z"
                                            fill="#E79225"
                                          />
                                          <path
                                            d="M67.4999 6.72668L64.5781 9.60973L64.7293 9.79278L83.0492 9.73176L83.2171 9.60973L85.9878 6.71143L67.4999 6.72668Z"
                                            fill="#FFF16D"
                                          />
                                          <path
                                            d="M64.5781 9.60986H83.2171V27.7472H64.5781V9.60986Z"
                                            fill="url(#paint0_linear_2212_13177)"
                                          />
                                          <path
                                            d="M80.3802 16.1388C80.0108 15.2998 79.4566 14.5371 78.7346 13.8811C78.0461 13.2405 77.2737 12.7523 76.4005 12.432C75.5441 12.1116 74.6206 11.9438 73.6131 11.9438C72.6055 11.9438 71.6652 12.1116 70.8088 12.432C69.9356 12.7523 69.1632 13.2405 68.4747 13.8811C67.7527 14.5371 67.2154 15.2998 66.8459 16.1388C66.4765 16.9777 66.3086 17.893 66.3086 18.8998C66.3086 19.8761 66.4933 20.7913 66.8627 21.6455C67.2321 22.4998 67.7695 23.2625 68.4915 23.9337C69.1632 24.5591 69.9356 25.032 70.792 25.3523C71.6484 25.6727 72.6055 25.8405 73.6298 25.8405C74.6206 25.8405 75.5441 25.6727 76.4005 25.3523C77.2569 25.032 78.0461 24.5591 78.7346 23.9337C79.4566 23.2625 80.0108 22.4998 80.3802 21.6608C80.7496 20.8218 80.9343 19.8913 80.9343 18.915C80.9343 17.893 80.7496 16.9777 80.3802 16.1388ZM76.5348 22.1184C75.8128 22.8964 74.8557 23.293 73.6131 23.293C72.3705 23.293 71.3965 22.8964 70.6745 22.1184C69.9524 21.3405 69.5998 20.2574 69.5998 18.8845C69.5998 17.4811 69.9692 16.3981 70.6745 15.6049C71.3965 14.8116 72.3537 14.4303 73.6131 14.4303C74.8557 14.4303 75.8128 14.8269 76.5348 15.6049C77.2401 16.3981 77.6095 17.4811 77.6095 18.8845C77.6095 20.2574 77.2569 21.3405 76.5348 22.1184Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M62.7472 5.20142V5.29294L65.1316 21.9353L63.7379 25.4438L63.5532 25.3218L61.1016 9.36582L61.1519 9.15226L62.68 5.29294L62.7472 5.20142Z"
                                            fill="#009ADA"
                                          />
                                          <path
                                            d="M44.3951 7.52006L62.7486 5.20142L61.2038 9.19803L60.9855 9.41159L43.8242 11.6997L43.9082 8.84718L44.3951 7.52006Z"
                                            fill="#91C9ED"
                                          />
                                          <path
                                            d="M61.2028 9.198L63.7384 25.4438L45.6536 27.7472L43.2188 12.0505L44.2766 11.3031L61.2028 9.198Z"
                                            fill="url(#paint1_linear_2212_13177)"
                                          />
                                          <path
                                            d="M58.1295 12.31C58.0455 11.8066 57.8608 11.4252 57.5585 11.1659C57.3067 10.9676 57.0044 10.8608 56.6518 10.8608C56.5678 10.8608 56.4671 10.8608 56.3663 10.8761C55.8961 10.9371 55.5435 11.1354 55.3252 11.4558C55.1573 11.6846 55.0901 11.9744 55.0901 12.31C55.0901 12.432 55.1069 12.5693 55.1237 12.7066L55.7786 16.932L50.5731 17.6337L49.9182 13.4083C49.8343 12.9202 49.6496 12.5388 49.3473 12.2795C49.0954 12.0659 48.7932 11.9591 48.4573 11.9591C48.3734 11.9591 48.2894 11.9591 48.2055 11.9744C47.7185 12.0354 47.3491 12.2337 47.114 12.5541C46.9461 12.7829 46.8789 13.0727 46.8789 13.4083C46.8789 13.5303 46.8957 13.6676 46.9125 13.8202L48.6924 24.8185C48.7764 25.3219 48.9611 25.7032 49.2969 25.9625C49.5488 26.1608 49.8511 26.2524 50.2205 26.2524C50.3212 26.2524 50.422 26.2524 50.5227 26.2371C50.9761 26.1761 51.312 25.9778 51.5303 25.6574C51.6814 25.4286 51.7485 25.1541 51.7485 24.8337C51.7485 24.7117 51.7318 24.5744 51.715 24.4371L50.9929 20.0897L56.1984 19.388L56.9204 23.7354C57.0044 24.2388 57.1891 24.6202 57.5082 24.8642C57.76 25.0625 58.0623 25.1693 58.4149 25.1693C58.4989 25.1693 58.5996 25.1693 58.7004 25.1541C59.1706 25.093 59.5232 24.8947 59.7415 24.5744C59.8926 24.3456 59.9766 24.071 59.9766 23.7354C59.9766 23.6134 59.9598 23.4761 59.943 23.3388L58.1295 12.31Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M27.2156 0.960693L20.6836 15.0556L21.5736 21.2488L21.6239 21.2336L28.962 6.23866L28.9284 5.91832L27.35 1.159L27.2156 0.960693Z"
                                            fill="#66BF6B"
                                          />
                                          <path
                                            d="M27.2148 0.960693L28.9108 6.13188L28.9444 6.23866L45.0982 12.8132L45.1486 12.7827L43.7716 7.84035L27.2148 0.960693Z"
                                            fill="#98D0A0"
                                          />
                                          <path
                                            d="M28.9123 6.13184L45.15 12.7827L37.812 27.8996L21.5742 21.2488L28.9123 6.13184Z"
                                            fill="url(#paint2_linear_2212_13177)"
                                          />
                                          <path
                                            d="M40.2301 14.003C39.8775 13.1488 39.3905 12.4166 38.7524 11.8064C38.1143 11.1962 37.3419 10.7081 36.4352 10.3573C35.5284 10.0064 34.6216 9.83862 33.6981 9.83862H33.6477C32.7074 9.83862 31.7838 10.0369 30.877 10.403C29.9199 10.7844 29.0971 11.303 28.3919 11.9895C27.6866 12.6607 27.1157 13.4844 26.6791 14.4301C26.2425 15.3607 26.0074 16.3064 25.957 17.2369V17.5573C25.957 18.381 26.1082 19.1895 26.4272 19.9827C26.763 20.8217 27.25 21.5386 27.8881 22.1488C28.5262 22.759 29.3154 23.2471 30.2557 23.5979C31.1457 23.9488 32.0525 24.1166 32.976 24.1166H32.9928C33.9164 24.1166 34.8399 23.9335 35.7467 23.5827C36.7038 23.2013 37.5434 22.6674 38.2487 21.981C38.9539 21.3098 39.5416 20.5013 39.9782 19.5556C40.4148 18.6098 40.6499 17.6793 40.7003 16.7488V16.4742C40.7171 15.6352 40.566 14.8115 40.2301 14.003ZM36.9893 18.3963C36.3848 19.7081 35.562 20.6081 34.5713 21.0963C34.0339 21.3556 33.4798 21.4929 32.9257 21.4929C32.4387 21.4929 31.9181 21.3861 31.3976 21.1878C30.2557 20.7454 29.5505 20.0437 29.2482 19.0369C29.1475 18.7013 29.0971 18.3505 29.0971 17.9844C29.0971 17.2522 29.2986 16.4437 29.7016 15.5742C30.3229 14.2318 31.1457 13.3166 32.1364 12.8132C32.6738 12.5386 33.2279 12.4166 33.782 12.4166C34.2858 12.4166 34.7896 12.5234 35.3269 12.7217C36.4519 13.164 37.1572 13.8657 37.4595 14.8725C37.5602 15.1929 37.6106 15.5437 37.6106 15.9098C37.6106 16.6725 37.4091 17.4963 36.9893 18.3963Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M19.3879 3.35571L22.041 19.4947L20.832 25.1693L20.6641 24.971L18.0781 9.38114V9.07605L19.22 3.63029L19.3879 3.35571Z"
                                            fill="#760D16"
                                          />
                                          <path
                                            d="M0.0117188 11.6998L1.27111 5.9947L19.3895 3.35571L18.1637 9.16758V9.54893L0.230013 11.8523L0.0117188 11.6998Z"
                                            fill="#EF463E"
                                          />
                                          <path
                                            d="M18.1637 9.16748L20.8336 25.1692L2.89992 27.7166L0.0117188 11.6997L18.1637 9.16748Z"
                                            fill="url(#paint3_linear_2212_13177)"
                                          />
                                          <path
                                            d="M16.234 22.6218C16.0996 22.4693 15.8981 22.3625 15.663 22.2862C15.428 22.21 15.1425 22.1794 14.7899 22.1794C14.4708 22.1794 14.1014 22.21 13.6984 22.271L8.96308 23.0032C9.01346 22.6676 9.19817 22.2405 9.51722 21.7066C9.86985 21.1117 10.4072 20.3947 11.0957 19.571C11.3307 19.2811 11.5154 19.0676 11.6498 18.915C11.7337 18.8083 11.8681 18.671 12.036 18.4727C13.1275 17.1761 13.7823 16.1235 14.051 15.2998C14.2021 14.8269 14.2861 14.354 14.3197 13.8811C14.3365 13.7439 14.3365 13.6218 14.3365 13.4998C14.3365 13.1642 14.3029 12.8286 14.2357 12.493C14.1854 12.1879 14.1014 11.9439 13.9839 11.7455C13.8663 11.5472 13.732 11.3947 13.5641 11.3032C13.3793 11.1964 13.0939 11.1506 12.7413 11.1506C12.4558 11.1506 12.1032 11.1811 11.6834 11.2422L6.20922 12.0964C5.55434 12.2032 5.05058 12.371 4.74833 12.6455C4.49645 12.8591 4.37891 13.1337 4.37891 13.4388C4.37891 13.515 4.37891 13.6066 4.3957 13.6981C4.47966 14.1252 4.71474 14.4303 5.10096 14.5828C5.33604 14.6744 5.60471 14.7201 5.94055 14.7201C6.15884 14.7201 6.41072 14.7049 6.67939 14.6591L11.2468 13.9269C11.2468 14.0032 11.2636 14.0794 11.2636 14.1405C11.2636 14.3998 11.2132 14.6591 11.1124 14.9032C10.9781 15.254 10.6423 15.7422 10.0881 16.3676C9.93701 16.5354 9.70193 16.81 9.38288 17.1608C8.14028 18.5184 7.26711 19.6778 6.72977 20.6388C6.34355 21.31 6.09168 21.9506 5.94055 22.6066C5.85659 22.9879 5.80621 23.3388 5.80621 23.6896C5.80621 23.9337 5.82301 24.1778 5.87338 24.4066C5.94055 24.7422 6.02451 25.0167 6.14205 25.2303C6.2596 25.4439 6.42751 25.6117 6.61222 25.7032C6.79693 25.7947 7.04881 25.8252 7.41823 25.8252C7.87161 25.8252 8.49291 25.7642 9.28213 25.6422L14.2525 24.8642C15.1257 24.7269 15.747 24.5286 16.0996 24.2693C16.3851 24.0557 16.5362 23.7659 16.5362 23.4303C16.5362 23.3388 16.5194 23.2472 16.5026 23.1557C16.469 22.9574 16.3851 22.7744 16.234 22.6218Z"
                                            fill="white"
                                          />
                                        </g>
                                        <defs>
                                          <linearGradient
                                            id="paint0_linear_2212_13177"
                                            x1="996.452"
                                            y1="35.5643"
                                            x2="996.452"
                                            y2="1768.58"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            <stop
                                              offset="0.00562"
                                              stop-color="#FFE513"
                                            />
                                            <stop
                                              offset="1"
                                              stop-color="#FDB924"
                                            />
                                          </linearGradient>
                                          <linearGradient
                                            id="paint1_linear_2212_13177"
                                            x1="135.803"
                                            y1="259.5"
                                            x2="1854.68"
                                            y2="1794.07"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            <stop
                                              offset="0.00562"
                                              stop-color="#008CD2"
                                            />
                                            <stop
                                              offset="1"
                                              stop-color="#00649D"
                                            />
                                          </linearGradient>
                                          <linearGradient
                                            id="paint2_linear_2212_13177"
                                            x1="1200.41"
                                            y1="610.819"
                                            x2="1200.41"
                                            y2="2129.12"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            <stop stop-color="#26A146" />
                                            <stop
                                              offset="1"
                                              stop-color="#008A52"
                                            />
                                          </linearGradient>
                                          <linearGradient
                                            id="paint3_linear_2212_13177"
                                            x1="910.637"
                                            y1="161.419"
                                            x2="1140.06"
                                            y2="1746.33"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            <stop stop-color="#D92231" />
                                            <stop
                                              offset="1"
                                              stop-color="#BA2234"
                                            />
                                          </linearGradient>
                                          <clipPath id="clip0_2212_13177">
                                            <rect
                                              width="86"
                                              height="27"
                                              fill="white"
                                              transform="translate(0 0.960693)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="45"
                                        height="46"
                                        viewBox="0 0 45 46"
                                        fill="none"
                                      >
                                        <path
                                          d="M35.8485 8.97994C32.0942 6.65555 27.1517 7.20934 22.7436 9.954C18.3493 7.20934 13.4038 6.65555 9.65406 8.97994C3.72249 12.6532 3.00135 22.1131 8.04486 30.1104C11.7624 36.0063 17.5761 39.461 22.7512 39.3973C27.9264 39.461 33.7401 36.0063 37.4576 30.1104C42.495 22.1131 41.7801 12.6532 35.8485 8.97994ZM10.7718 28.4218C9.73183 26.7881 8.94718 25.0079 8.44447 23.1418C7.99783 21.5218 7.82707 19.8393 7.9392 18.1637C8.16427 15.2082 9.37845 12.9065 11.3567 11.6821C13.3349 10.4577 15.95 10.3834 18.7351 11.4788C19.1531 11.6442 19.5666 11.8354 19.9768 12.0463C18.4292 13.4446 17.0834 15.0478 15.9776 16.8103C12.9153 21.6656 11.9814 27.0684 13.0501 31.3758C12.1979 30.4648 11.435 29.4757 10.7718 28.4218ZM37.0596 23.1403C36.5561 25.0063 35.7716 26.7862 34.7323 28.4203C34.0684 29.4757 33.3056 30.4668 32.454 31.3803C33.4093 27.5189 32.7602 22.7883 30.4176 18.3519C30.3801 18.2788 30.3277 18.2143 30.2636 18.1626C30.1995 18.1109 30.1251 18.0731 30.0452 18.0516C29.9655 18.0302 29.8821 18.0256 29.8003 18.0381C29.7186 18.0506 29.6404 18.08 29.5708 18.1243L22.2675 22.6456C22.2007 22.6869 22.143 22.7407 22.0974 22.8039C22.0519 22.8673 22.0192 22.9389 22.0016 23.0148C21.984 23.0906 21.9816 23.1691 21.9947 23.2458C22.0076 23.3225 22.0359 23.396 22.0776 23.4618L23.1493 25.1596C23.1907 25.2256 23.2449 25.2828 23.3087 25.328C23.3724 25.3732 23.4446 25.4054 23.5209 25.4229C23.5974 25.4403 23.6766 25.4428 23.7538 25.4298C23.8312 25.4169 23.9051 25.3891 23.9715 25.3479L28.7057 22.4165C28.8589 22.8718 29.0121 23.3268 29.1268 23.7821C29.5734 25.4 29.7446 27.0802 29.6336 28.754C29.4086 31.7081 28.1944 34.0096 26.2162 35.2355C25.1959 35.8537 24.0266 36.1891 22.8309 36.2066H22.6792C21.4834 36.1895 20.3141 35.8541 19.2939 35.2355C17.3143 34.0096 16.1001 31.7081 15.875 28.754C15.7636 27.0783 15.9343 25.3961 16.3803 23.7759C17.4064 20.0278 19.5276 16.6638 22.4771 14.1067C23.7491 13.0003 25.1979 12.1112 26.7643 11.4758C29.5417 10.3803 32.1615 10.4532 34.1413 11.6791C36.1209 12.905 37.3337 15.2051 37.5587 18.1607C37.6723 19.8365 37.5036 21.5193 37.0596 23.1403Z"
                                          fill="#1BDBDB"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="addnewaccoiuntcss">
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="45"
                                        height="46"
                                        viewBox="0 0 45 46"
                                        fill="none"
                                      >
                                        <path
                                          d="M35.3593 35.6482H9.35668C7.29234 35.6482 5.625 33.9808 5.625 31.9166V15.0049C5.625 12.9405 7.29234 11.2732 9.35668 11.2732H35.3593C37.4237 11.2732 39.0909 12.9405 39.0909 15.0049V31.9166C39.0514 33.9808 37.3839 35.6482 35.3593 35.6482Z"
                                          fill="#2948FF"
                                        />
                                        <path
                                          d="M24.4421 25.8027C23.1718 26.6761 21.5046 26.6761 20.2341 25.8027L17.1773 23.6986L15.8673 25.2072L19.9562 28.9786C21.2662 30.3284 23.4099 30.3284 24.72 28.9786L28.809 25.2072L27.4989 23.6986L24.4421 25.8027ZM5.625 15.7986L15.0336 24.4529L16.2643 23.0635L5.625 15.7986ZM28.4518 23.0635L29.6426 24.4529L39.0514 15.7986L28.4518 23.0635Z"
                                          fill="#103BB2"
                                        />
                                        <path
                                          d="M29.6444 24.4521L28.8107 25.2065L37.3062 35.0517C37.6238 34.8531 37.9017 34.615 38.1398 34.3371L29.6444 24.4521ZM6.5 34.3371C6.7382 34.615 7.01609 34.8531 7.33368 35.0517L15.8292 25.2065L14.9955 24.4521L6.5 34.3371Z"
                                          fill="#1943C2"
                                        />
                                        <path
                                          d="M28.4534 23.0642L27.5005 23.6993L28.8106 25.2079L29.6444 24.4536L28.4534 23.0642ZM15.0352 24.4536L15.8688 25.2079L17.1789 23.6993L16.2658 23.0642L15.0352 24.4536Z"
                                          fill="#112E85"
                                        />
                                        <path
                                          d="M37.9794 12.3844C37.3046 11.7095 36.3915 11.3125 35.3593 11.3125H9.35668C8.32451 11.3125 7.41144 11.7095 6.73656 12.3844C6.02199 13.0592 5.625 13.9723 5.625 15.0045V15.7587L16.2643 23.0236L17.1773 23.6588L20.2341 25.7628C21.5046 26.6361 23.1718 26.6361 24.4421 25.7628L27.4989 23.6588L28.4121 23.0236L39.0514 15.7587V15.0045C39.0514 13.9723 38.6542 13.0592 37.9794 12.3844Z"
                                          fill="#396AFC"
                                        />
                                      </svg>
                                    </div>
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="45"
                                        height="46"
                                        viewBox="0 0 45 46"
                                        fill="none"
                                      >
                                        <path
                                          d="M18.1297 9.13508C19.8267 8.58634 21.6407 8.4339 23.4192 8.46439C23.4064 8.64985 23.3835 9.02329 23.3708 9.2113C20.9462 9.57458 18.725 10.8524 17.0789 12.6562C16.28 13.1465 15.9111 14.0509 15.2852 14.7165C14.5473 16.3678 13.8604 18.0597 13.6187 19.8659C13.2421 22.5359 13.7103 25.247 13.4151 27.9243C13.0818 28.1988 12.7536 28.4833 12.4254 28.7679C12.2779 28.8037 11.9827 28.877 11.8351 28.9151C11.1278 29.2404 10.3391 29.111 9.59111 29.06C9.20437 28.76 8.80492 28.4756 8.40294 28.1962C8.36223 27.9397 8.31898 27.6856 8.27572 27.4316C7.15625 24.7183 7.33181 21.53 8.27064 18.7838C8.40547 18.3443 8.53014 17.9022 8.6421 17.4576C9.12551 16.5202 9.66489 15.6107 10.2017 14.7012C11.222 13.6673 12.0616 12.4453 13.2701 11.6069C13.9749 10.9769 14.9341 10.7178 15.5981 10.042C15.7635 10.0217 16.0942 9.97851 16.2596 9.95818L16.7456 9.51107C16.9008 9.50091 17.2112 9.47803 17.3664 9.46534C17.6233 9.35863 17.8778 9.24913 18.1297 9.13508Z"
                                          fill="#FEDE15"
                                        />
                                        <path
                                          d="M24.7092 9.003C27.5181 8.93696 30.1208 10.324 32.2555 12.0363C34.7387 14.211 36.5833 17.1681 37.1659 20.4401C37.9648 23.9511 37.2906 27.706 35.5707 30.8456C35.2272 31.4531 34.7642 31.9815 34.2807 32.4818C34.7082 30.8177 35.2348 29.1536 35.2832 27.4236C35.25 26.1407 35.0033 24.868 34.6292 23.6434C33.1408 19.4644 29.3779 16.5327 25.3504 14.9601C24.1112 14.5664 23.0708 13.6721 22.5898 12.4552C22.6077 11.6372 22.8417 10.8547 23.1572 10.1079C23.626 9.67595 24.1474 9.30474 24.7092 9.003Z"
                                          fill="#49AB30"
                                        />
                                        <path
                                          d="M20.5408 17.6942C21.8385 16.7974 23.5711 16.9701 24.8838 17.7323C24.8585 17.839 24.8051 18.0524 24.777 18.1591C25.0747 18.2658 25.4996 18.2658 25.67 18.5935C26.3799 19.6224 26.5325 20.9103 26.5732 22.1298C27.4282 23.1461 27.9905 24.3781 28.0057 25.7219C27.5325 25.5519 27.077 25.0923 26.5657 25.181C26.2629 25.5569 26.0441 25.9891 25.7896 26.3953C26.4791 26.5096 27.0746 27.0024 26.9143 27.7619C25.4868 28.4047 23.6371 28.5725 22.3803 27.4876C21.1515 28.3794 19.541 28.3693 18.2103 27.7061C18.1391 27.0609 18.4647 26.6109 19.0702 26.4001C18.6963 25.9584 18.3782 25.4754 18.106 24.9673C17.6709 25.1782 17.2384 25.394 16.8008 25.6049C16.956 24.2508 17.5666 22.9807 18.564 22.0458C18.6148 20.5036 18.9303 18.8219 20.1975 17.7955C21.1269 17.8676 20.4474 17.6292 20.5408 17.6942Z"
                                          fill="#2789B7"
                                        />
                                        <path
                                          d="M29.2299 29.6445C30.0007 29.0424 30.9879 28.989 31.9243 29.0831C33.0284 29.5757 33.7128 30.5767 34.0104 31.7226C33.8476 32.3882 33.7713 33.1275 33.2853 33.6585C31.4713 35.7493 29.0111 37.2735 26.3191 37.9365C22.7011 38.9807 18.7372 38.4092 15.4093 36.7196C12.4275 35.1881 10.0944 32.5584 8.73828 29.5151C8.85785 29.5305 9.09701 29.5631 9.21659 29.5787C10.6159 31.3266 12.5241 32.6475 14.5952 33.4834C15.3483 33.7042 16.1141 33.8719 16.8825 34.0294C17.8849 34.1664 18.9102 34.1869 19.9126 34.0217C21.1466 33.8976 22.3424 33.5415 23.495 33.0947C25.6169 32.3222 27.4132 30.9399 29.2299 29.6445Z"
                                          fill="#F80A06"
                                        />
                                      </svg>
                                    </div>
                                    <div className="newemailbox">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="45"
                                        height="46"
                                        viewBox="0 0 45 46"
                                        fill="none"
                                      >
                                        <mask
                                          id="mask0_2214_13231"
                                          style={{ maskType: "luminance" }}
                                          maskUnits="userSpaceOnUse"
                                          x="6"
                                          y="7"
                                          width="33"
                                          height="33"
                                        >
                                          <path
                                            d="M38.4375 7.52319H6.5625V39.3982H38.4375V7.52319Z"
                                            fill="white"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_2214_13231)">
                                          <path
                                            d="M22.4998 20.7026C24.0236 20.7026 25.2585 21.9373 25.2585 23.4605C25.2585 24.9843 24.0236 26.2192 22.4998 26.2192C20.9764 26.2192 19.7415 24.9838 19.7415 23.4605C19.7415 21.9373 20.9764 20.7026 22.4998 20.7026ZM13.101 23.4605C13.101 18.2697 17.309 14.0618 22.4998 14.0618C27.6913 14.0618 31.899 18.2697 31.899 23.4605C31.899 23.8042 31.8806 24.1432 31.8446 24.4766C31.7732 25.3929 32.4456 26.0923 33.3561 26.0923C34.9011 26.0923 35.0657 24.1001 35.0657 23.4605C35.0657 16.5203 29.4399 10.8946 22.4998 10.8946C15.5596 10.8946 9.9339 16.5204 9.9339 23.4605C9.9339 30.4004 15.5596 36.0264 22.4996 36.0264C26.1853 36.0264 29.5005 34.4403 31.7993 31.913L34.3824 34.0824C31.4646 37.3441 27.2218 39.3988 22.4998 39.3988C13.6978 39.3988 6.5625 32.2627 6.5625 23.4605C6.5625 14.6585 13.6978 7.52319 22.4998 7.52319C31.3022 7.52319 38.4375 14.6585 38.4375 23.4607C38.4375 26.9986 36.7528 29.8717 33.3692 29.8717C31.8799 29.8717 30.9748 29.1896 30.4806 28.4279C28.8208 31.0886 25.8675 32.8601 22.4998 32.8601C17.3089 32.8601 13.101 28.6513 13.101 23.4605ZM22.4998 17.433C19.1711 17.433 16.4722 20.1314 16.4722 23.4605C16.4722 26.7896 19.1711 29.4884 22.4998 29.4884C25.8287 29.4884 28.5278 26.7896 28.5278 23.4605C28.5278 20.1314 25.8287 17.433 22.4998 17.433Z"
                                            fill="#AF252A"
                                          />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="viewmorebox">
                                    <div className="createschedulebutton">
                                      View More
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Modal>
          </div>
        </div>
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="modalPopup"
            style={{ width: window.innerWidth / 1.9 }}
          >
            <div className="modaltext">Create a new list</div>
            <div className="modalsubtext">What would you like to name it?</div>

            <div className="modalmoxtextlabel">List name</div>
            <TextField
              autoComplete="off"
              value={listName}
              onChange={(e) => {
                setListName(e.target.value);
              }}
              variant="standard"
              placeholder="Ex:List-sample-D"
              InputProps={{
                disableUnderline: true,

                sx: {
                  display: "flex",
                  padding: "10px 16px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  width: window.innerWidth / 2.04,
                  "& input": {
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "32px",
                // width: window.innerWidth / 2.04,
              }}
            >
              <div
                style={{ alignItems: "center", display: "flex", gap: "10px" }}
              >
                <div
                  className="cancelbuttonmodal"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  className="continuebuttonmodal"
                  onClick={() => {
                    createNewNameList();
                  }}
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={open5}
          onClose={() => {
            setOpen5(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="modalPopup"
            style={{ top: "10%", left: "38%", width: "30vw" }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                cursor: "pointer",
              }}
            >
              <CancelOutlinedIcon
                onClick={() => {
                  setOpen5(false);
                }}
              />
            </div>
            <div className="newpopupselecthead">
              Select elements here to build email sequences with ease
            </div>
            <div
              style={{ flexDirection: "column", gap: "10px", display: "flex" }}
            >
              <div
                className="emailright"
                style={{
                  flexDirection: "row",
                  gap: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={(event) => {
                  onDragStart(event, "email");
                }}
                // draggable
              >
                <div className="insideemailanmdicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 16.5H8"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 12.5H5"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Email
                </div>
                <div className="insidemailboxtextsmall">
                  The email is the campaign's content and design sent to the
                  audience.
                </div>
              </div>
              <div
                className="emailright"
                style={{
                  flexDirection: "row",
                  gap: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents:
                    selPosition &&
                    !(selPosition.data.label === "email") &&
                    "none",
                  opacity:
                    selPosition &&
                    !(selPosition.data.label === "email") &&
                    "0.4",
                }}
                onClick={(event) => onDragStart(event, "Trigger")}
                // draggable
              >
                <div className="insideemailanmdicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 9V16"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.25 8.5C7.04493 8.5 8.5 7.04493 8.5 5.25C8.5 3.45507 7.04493 2 5.25 2C3.45507 2 2 3.45507 2 5.25C2 7.04493 3.45507 8.5 5.25 8.5Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5 22C6.65685 22 8 20.6569 8 19C8 17.3431 6.65685 16 5 16C3.34315 16 2 17.3431 2 19C2 20.6569 3.34315 22 5 22Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19C16 20.6569 17.3431 22 19 22Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.12988 9C5.57988 10.75 7.17988 12.05 9.06988 12.04L12.4999 12.03C15.1199 12.02 17.3499 13.7 18.1699 16.04"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Trigger
                </div>
                <div className="insidemailboxtextsmall">
                  The action that starts your email campaign, like a user's
                  signup or purchase.
                </div>
              </div>
              <div
                style={{
                  flexDirection: "row",
                  gap: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents:
                    selPosition &&
                    !(
                      selPosition.data.label === "email" ||
                      selPosition.data.label === "Trigger"
                    ) &&
                    "none",
                  opacity:
                    selPosition &&
                    !(
                      selPosition.data.label === "email" ||
                      selPosition.data.label === "Trigger"
                    ) &&
                    "0.4",
                }}
                className="emailright"
                onClick={(event) => onDragStart(event, "Delay")}
                // draggable
              >
                <div className="insideemailanmdicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 8V13"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 2H15"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Delay
                </div>
                <div className="insidemailboxtextsmall">
                  Setting time intervals between email sends to time your
                  campaign.
                </div>
              </div>
              <div
                style={{
                  flexDirection: "row",
                  gap: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents:
                    selPosition && selPosition.data.label === "Start" && "none",
                  opacity:
                    selPosition && selPosition.data.label === "Start" && "0.4",
                }}
                className="emailright"
                onClick={(event) => onDragStart(event, "Goal")}
                // draggable
              >
                <div className="insideemailanmdicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4.25977 11.02V15.99C4.25977 17.81 4.25977 17.81 5.97977 18.97L10.7098 21.7C11.4198 22.11 12.5798 22.11 13.2898 21.7L18.0198 18.97C19.7398 17.81 19.7398 17.81 19.7398 15.99V11.02C19.7398 9.2 19.7398 9.2 18.0198 8.04L13.2898 5.31C12.5798 4.9 11.4198 4.9 10.7098 5.31L5.97977 8.04C4.25977 9.2 4.25977 9.2 4.25977 11.02Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.6298 10.99L13.1998 11.88C13.2898 12.02 13.4898 12.16 13.6398 12.2L14.6598 12.46C15.2898 12.62 15.4598 13.16 15.0498 13.66L14.3798 14.47C14.2798 14.6 14.1998 14.83 14.2098 14.99L14.2698 16.04C14.3098 16.69 13.8498 17.02 13.2498 16.78L12.2698 16.39C12.1198 16.33 11.8698 16.33 11.7198 16.39L10.7398 16.78C10.1398 17.02 9.67978 16.68 9.71978 16.04L9.77978 14.99C9.78978 14.83 9.70978 14.59 9.60978 14.47L8.93978 13.66C8.52978 13.16 8.69978 12.62 9.32978 12.46L10.3498 12.2C10.5098 12.16 10.7098 12.01 10.7898 11.88L11.3598 10.99C11.7198 10.45 12.2798 10.45 12.6298 10.99Z"
                      stroke="#1C485F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Goal
                </div>
                <div className="insidemailboxtextsmall">
                  The desired recipient action that measures campaign success.
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modals
          x={modalPosition.x}
          y={modalPosition.y}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
        <Modal
          open={open6}
          onClose={() => {
            setOpen6(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div className="modaltext">Confirm Delete</div>
            <div className="modalsubtext">
              Are you sure you want to delete this schedule?
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen6(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  deleteScheduleById();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className={classes.modal}
          open={open7}
          onClose={() => {
            setOpen7(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="modalPopupDelete"
            style={{
              left: "68%",
              gap: "0px",
              padding: "12px",
              top: "38%",
              border: "1px solid #1c485f",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div className="modaltext">We found the following errors</div>
              <div style={{ float: "right" }}>
                {" "}
                <CloseIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen7(false);
                  }}
                />
              </div>
            </div>
            {erorMessage.length !== 0 &&
              erorMessage.map((val) => {
                return (
                  <div
                    className="modalsubtext"
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "6px",
                        width: "6px",
                        backgroundColor: "red",
                        borderRadius: "50%",
                      }}
                    ></div>
                    {val}
                  </div>
                );
              })}
          </div>
        </Modal>
      </div>
      <div
        className="savenextbottonblock"
        style={{
          height: "50px",
          borderTop: "1px solid #DDD",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {type !== "prospect" ? (
          <button
            onClick={() => {
              setLocalStorageData();
              if (type === "sequence") {
                setType("prospect");
              } else if (type === "sending") {
                setType("sequence");
              } else if (type === "review") {
                setType("sending");
              }
            }}
            style={{
              backgroundColor: "#fff",
              fontFamily: "Source Sans 3",
              color: "#1C485F",
              fontSize: "13px",
              fontStyle: "normal",
              padding: "7px 14px",
              borderRadius: "4px",
              outline: "none",
              border: "1px solid #1C485F",
            }}
          >
            Previous
          </button>
        ) : (
          <button
            onClick={() => {
              history.goBack();
            }}
            style={{
              backgroundColor: "#fff",
              fontFamily: "Source Sans 3",
              color: "#1C485F",
              fontSize: "13px",
              fontStyle: "normal",
              padding: "7px 14px",
              borderRadius: "4px",
              outline: "none",
              border: "1px solid #1C485F",
            }}
          >
            Back
          </button>
        )}

        <div style={{ display: "flex", gap: "10px" }}>
          <button
          disabled={publishLoader}
            style={{
              pointerEvents: type === "prospect" && !nameList ? "none" : "auto",
              fontFamily: "Source Sans 3",
              color: "#fff",
              fontSize: "13px",
              fontStyle: "normal",
              padding: "7px 18px",
              borderRadius: "4px",
              outline: "none",
              border: "1px solid transparent",
            }}
            className="bg-primary"
            onClick={() => {
              nextStepsOfCampaign();
            }}
          >
            {type === "review" ? (
              <>
                {publishLoader ? (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "white",
                    }}
                  />
                ) : (
                  <>{locData.state.from === "edit" ? "Update" : `Publish`}</>
                )}
              </>
            ) : (
              <>
                {sequenceLoader ? (
                  <CircularProgress
                    size={20}
                    style={{
                      color: "white",
                    }}
                  />
                ) : (
                  "Next"
                )}
              </>
            )}
          </button>
        </div>
      </div>
      {openDrawerForCreateList && handleCreateListInDrawerComponent()}
      {(openEmailEmailInstructionModal || openEmailAccountDrawer) && (
        <EmailAccountsCopy
          statusObj={catchPropsData}
          openInstructionModal={openEmailEmailInstructionModal}
          openEmailAccountDrawer={openEmailAccountDrawer}
          setOpenEmailAccountDrawer={setOpenEmailAccountDrawer}
          setterFunForEmailInstructionModal={setOpenEmailEmailInstructionModal}
        />
      )}
      {openDeleteCard && openDeleteModal()}
      {openMuiModal && muiModal()}
      <ToastContainer />
    </div>
  );
}
